!function (t, e) {
  "object" == typeof exports && "undefined" != typeof module ? e(exports, require("react")) : "function" == typeof define && define.amd ? define(["exports", "react"], e) : e((t = t || self).ReactCharts = {}, t.React);
}(this, function (t, e) {
  "use strict";

  function n(t) {
    return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    })(t);
  }

  function r(t, e) {
    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
  }

  function i(t, e) {
    for (var n = 0; n < e.length; n++) {
      var r = e[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
    }
  }

  function o(t, e, n) {
    return e in t ? Object.defineProperty(t, e, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : t[e] = n, t;
  }

  function a() {
    return (a = Object.assign || function (t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = arguments[e];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
      }

      return t;
    }).apply(this, arguments);
  }

  function s(t, e) {
    var n = Object.keys(t);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(t);
      e && (r = r.filter(function (e) {
        return Object.getOwnPropertyDescriptor(t, e).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function u(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = null != arguments[e] ? arguments[e] : {};
      e % 2 ? s(Object(n), !0).forEach(function (e) {
        o(t, e, n[e]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : s(Object(n)).forEach(function (e) {
        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
      });
    }

    return t;
  }

  function c(t) {
    return (c = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
      return t.__proto__ || Object.getPrototypeOf(t);
    })(t);
  }

  function l(t, e) {
    return (l = Object.setPrototypeOf || function (t, e) {
      return t.__proto__ = e, t;
    })(t, e);
  }

  function h(t, e) {
    if (null == t) return {};

    var n,
        r,
        i = function (t, e) {
      if (null == t) return {};
      var n,
          r,
          i = {},
          o = Object.keys(t);

      for (r = 0; r < o.length; r++) {
        n = o[r], e.indexOf(n) >= 0 || (i[n] = t[n]);
      }

      return i;
    }(t, e);

    if (Object.getOwnPropertySymbols) {
      var o = Object.getOwnPropertySymbols(t);

      for (r = 0; r < o.length; r++) {
        n = o[r], e.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(t, n) && (i[n] = t[n]);
      }
    }

    return i;
  }

  function f(t, e) {
    return !e || "object" != typeof e && "function" != typeof e ? function (t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }(t) : e;
  }

  function d(t) {
    var e = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }();

    return function () {
      var n,
          r = c(t);

      if (e) {
        var i = c(this).constructor;
        n = Reflect.construct(r, arguments, i);
      } else n = r.apply(this, arguments);

      return f(this, n);
    };
  }

  function y(t, e) {
    return function (t) {
      if (Array.isArray(t)) return t;
    }(t) || function (t, e) {
      if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(t))) return;
      var n = [],
          r = !0,
          i = !1,
          o = void 0;

      try {
        for (var a, s = t[Symbol.iterator](); !(r = (a = s.next()).done) && (n.push(a.value), !e || n.length !== e); r = !0) {
          ;
        }
      } catch (t) {
        i = !0, o = t;
      } finally {
        try {
          r || null == s.return || s.return();
        } finally {
          if (i) throw o;
        }
      }

      return n;
    }(t, e) || g(t, e) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }

  function p(t) {
    return function (t) {
      if (Array.isArray(t)) return m(t);
    }(t) || function (t) {
      if ("undefined" != typeof Symbol && Symbol.iterator in Object(t)) return Array.from(t);
    }(t) || g(t) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }

  function g(t, e) {
    if (t) {
      if ("string" == typeof t) return m(t, e);
      var n = Object.prototype.toString.call(t).slice(8, -1);
      return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? m(t, e) : void 0;
    }
  }

  function m(t, e) {
    (null == e || e > t.length) && (e = t.length);

    for (var n = 0, r = new Array(e); n < e; n++) {
      r[n] = t[n];
    }

    return r;
  }

  function _(t, e) {
    var _n2;

    if ("undefined" == typeof Symbol || null == t[Symbol.iterator]) {
      if (Array.isArray(t) || (_n2 = g(t)) || e && t && "number" == typeof t.length) {
        _n2 && (t = _n2);

        var r = 0,
            i = function i() {};

        return {
          s: i,
          n: function n() {
            return r >= t.length ? {
              done: !0
            } : {
              done: !1,
              value: t[r++]
            };
          },
          e: function e(t) {
            throw t;
          },
          f: i
        };
      }

      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }

    var o,
        a = !0,
        s = !1;
    return {
      s: function s() {
        _n2 = t[Symbol.iterator]();
      },
      n: function n() {
        var t = _n2.next();

        return a = t.done, t;
      },
      e: function e(t) {
        s = !0, o = t;
      },
      f: function f() {
        try {
          a || null == _n2.return || _n2.return();
        } finally {
          if (s) throw o;
        }
      }
    };
  }

  var x = (e = e && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e).createContext(),
      v = {
    getStatus: b,
    getStatusStyle: M,
    buildStyleGetters: function buildStyleGetters(t, e) {
      t.getStatusStyle = function (n, r) {
        var i = b(t, n);
        return t.style = M(t, i, r, e), t.style;
      }, t.datums.forEach(function (t) {
        t.getStatusStyle = function (n, r) {
          var i = b(t, n);
          return t.style = M(t, i, r, e), t.style;
        };
      });
    },
    getMultiAnchor: function getMultiAnchor(t) {
      var e,
          n,
          r = t.anchor,
          i = t.points,
          o = t.gridWidth,
          a = t.gridHeight,
          s = function s() {
        throw new Error("".concat(JSON.stringify(r), " is not a valid tooltip anchor option. You should use a single anchor option or 2 non-conflicting anchor options."));
      },
          u = i[0].anchor.x,
          c = i[0].anchor.x,
          l = i[0].anchor.y,
          h = i[0].anchor.y;

      if (i.forEach(function (t) {
        u = Math.min(t.anchor.x, u), c = Math.max(t.anchor.x, c), l = Math.min(t.anchor.y, l), h = Math.max(t.anchor.y, h);
      }), r.length > 2) return s();
      r = r.sort(function (t) {
        return t.includes("center") || t.includes("Center") ? 1 : -1;
      });

      for (var f = 0; f < r.length; f++) {
        var d = r[f];
        ["left", "right", "gridLeft", "gridRight"].includes(d) && (void 0 !== e && s(), "left" === d ? e = u : "right" === d ? e = c : "gridLeft" === d ? e = 0 : "gridRight" === d ? e = o : s()), ["top", "bottom", "gridTop", "gridBottom"].includes(d) && (void 0 !== n && s(), "top" === d ? n = l : "bottom" === d ? n = h : "gridTop" === d ? n = 0 : "gridBottom" === d ? n = a : s()), ["center", "gridCenter"].includes(d) && ("center" === d ? (void 0 === n && (n = (l + h) / 2), void 0 === e && (e = (u + c) / 2)) : "gridCenter" === d ? (void 0 === n && (n = a / 2), void 0 === e && (e = o / 2)) : s()), 1 === r.length && (r[0].includes("grid") ? r.push("gridCenter") : r.push("center"));
      }

      return {
        x: e,
        y: n
      };
    },
    getClosestPoint: function getClosestPoint(t, e) {
      if (!e || !t || !e.length) return;
      var n = 1 / 0,
          r = e[0];
      return e.forEach(function (e) {
        e.boundingPoints.forEach(function (i) {
          var o = Math.sqrt(Math.pow(i.x - t.x, 2) + Math.pow(i.y - t.y, 2));
          o < n && (n = o, r = e);
        });
      }), r;
    },
    normalizeGetter: function normalizeGetter(t) {
      if ("function" == typeof t) return t;
      return function (e) {
        return function (t, e, n) {
          if ("function" == typeof t) try {
            return t();
          } catch (t) {
            return e;
          }
          if (!e) return t;

          var r,
              i = function (t) {
            return function t(e) {
              var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
              if (Array.isArray(e)) for (var r = 0; r < e.length; r++) {
                t(e[r], n);
              } else n.push(e);
              return n;
            }(t).join(".").replace("[", ".").replace("]", "").split(".");
          }(e);

          try {
            r = i.reduce(function (t, e) {
              return t[e];
            }, t);
          } catch (t) {}

          return void 0 !== r ? r : n;
        }(e, t);
      };
    },
    isValidPoint: function isValidPoint(t) {
      if (null === t) return !1;
      if (void 0 === t) return !1;
      if ("string" == typeof t && "null" === t) return !1;
      return !0;
    },
    getAxisByAxisID: function getAxisByAxisID(t, e) {
      return t.find(function (t) {
        return t.id === e;
      }) || t[0];
    },
    getAxisIndexByAxisID: function getAxisIndexByAxisID(t, e) {
      var n = t.findIndex(function (t) {
        return t.id === e;
      });
      return n > -1 ? n : 0;
    },
    sumObjBy: function sumObjBy(t, e) {
      return Object.keys(t).map(function (e) {
        return t[e];
      }).reduce(function (t, n) {
        return t + n[e] || 0;
      }, 0);
    },
    translateX: function translateX(t) {
      return "translate3d(".concat(Math.round(t), "px, 0, 0)");
    },
    translateY: function translateY(t) {
      return "translate3d(0, ".concat(Math.round(t), "px, 0)");
    },
    translate: function translate(t, e) {
      return "translate3d(".concat(Math.round(t), "px, ").concat(Math.round(e), "px, 0)");
    },
    identity: function identity(t) {
      return t;
    },
    shallowDiff: function shallowDiff(t, e) {
      var n = Object.keys(t),
          r = Object.keys(e);
      if (n.length !== r.length) return !0;
      return Object.keys(t).some(function (n) {
        if (t[n] !== e[n]) return !0;
      });
    }
  };

  function b(t, e) {
    var n = {
      focused: !1,
      otherFocused: !1
    };
    if (!e) return n;

    if (void 0 !== t.primary) {
      for (var r = e.group.length, i = 0; i < r; i++) {
        if (e.group[i].seriesID === t.series.id && e.group[i].index === t.index) {
          n.focused = !0;
          break;
        }
      }

      n.otherFocused = !n.focused;
    } else e.series && (n.focused = e.series.id === t.id, n.otherFocused = !n.focused);

    return n;
  }

  function M(t, e, n, r) {
    return t.series && (r = u({}, r, {}, t.series.style)), function t() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      e = w(e, n);

      for (var r = 0; r < C.length; r++) {
        var i = C[r];
        e[i] = e[i] ? t(e[i], n) : {};
      }

      return e;
    }(n(u({}, t, {}, e)), r);
  }

  function w(t, e) {
    return u({}, t, {
      stroke: t.stroke || t.color || e.stroke || e.color,
      fill: t.fill || t.color || e.fill || e.color
    });
  }

  var C = ["area", "line", "rectangle", "circle"];

  var k,
      S = ["bottom", "height", "left", "right", "top", "width"],
      A = new Map(),
      E = function t() {
    var e = [];
    A.forEach(function (t, n) {
      var r = n.getBoundingClientRect();
      (function (t, e) {
        return void 0 === t && (t = {}), void 0 === e && (e = {}), S.some(function (n) {
          return t[n] !== e[n];
        });
      })(r, t.rect) && (t.rect = r, e.push(t));
    }), e.forEach(function (t) {
      t.callbacks.forEach(function (e) {
        return e(t.rect);
      });
    }), k = window.requestAnimationFrame(t);
  };

  var T = "undefined" != typeof window ? e.useLayoutEffect : e.useEffect;

  function D(t) {
    var n,
        r = y(e.useState(null === (n = t.current) || void 0 === n ? void 0 : n.parentElement), 2),
        i = r[0],
        o = r[1],
        a = y(e.useState({
      width: 0,
      height: 0
    }), 2),
        s = a[0],
        u = a[1],
        c = e.useRef(!1);
    return T(function () {
      var e, n;
      (null === (e = t.current) || void 0 === e ? void 0 : e.parentElement) !== i && o(null === (n = t.current) || void 0 === n ? void 0 : n.parentElement);
    }), T(function () {
      i && !c.current && (c.current = !0, u(i.getBoundingClientRect()));
    }, [i]), e.useEffect(function () {
      if (i) {
        var t,
            e,
            n = (t = i, e = u, {
          observe: function observe() {
            var n = 0 === A.size;
            A.has(t) ? A.get(t).callbacks.push(e) : A.set(t, {
              rect: void 0,
              hasRectChanged: !1,
              callbacks: [e]
            }), n && E();
          },
          unobserve: function unobserve() {
            var n = A.get(t);

            if (n) {
              var r = n.callbacks.indexOf(e);
              r >= 0 && n.callbacks.splice(r, 1), n.callbacks.length || A.delete(t), A.size || cancelAnimationFrame(k);
            }
          }
        });
        return n.observe(), function () {
          n.unobserve();
        };
      }
    }, [i]), {
      width: s.width,
      height: s.height
    };
  }

  function N(t) {
    var n = e.useRef();
    return n.current = t, n;
  }

  function R(t) {
    var n = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
        r = e.useRef();
    return n && (r.current = t), r.current;
  }

  function L(t) {
    var n = e.useRef();
    return e.useEffect(function () {
      n.current = t;
    }, [t]), n.current;
  }

  for (var P = require("performance-now"), O = "undefined" == typeof window ? global : window, U = ["moz", "webkit"], I = "AnimationFrame", V = O["request" + I], z = O["cancel" + I] || O["cancelRequest" + I], j = 0; !V && j < U.length; j++) {
    V = O[U[j] + "Request" + I], z = O[U[j] + "Cancel" + I] || O[U[j] + "CancelRequest" + I];
  }

  if (!V || !z) {
    var F = 0,
        B = 0,
        H = [];
    V = function V(t) {
      if (0 === H.length) {
        var e = P(),
            n = Math.max(0, 1e3 / 60 - (e - F));
        F = n + e, setTimeout(function () {
          var t = H.slice(0);
          H.length = 0;

          for (var e = 0; e < t.length; e++) {
            if (!t[e].cancelled) try {
              t[e].callback(F);
            } catch (t) {
              setTimeout(function () {
                throw t;
              }, 0);
            }
          }
        }, Math.round(n));
      }

      return H.push({
        handle: ++B,
        callback: t,
        cancelled: !1
      }), B;
    }, z = function z(t) {
      for (var e = 0; e < H.length; e++) {
        H[e].handle === t && (H[e].cancelled = !0);
      }
    };
  }

  function Y(t) {
    return V.call(O, t);
  }

  Y.cancel = function () {
    z.apply(O, arguments);
  }, Y.polyfill = function (t) {
    t || (t = O), t.requestAnimationFrame = V, t.cancelAnimationFrame = z;
  };
  var W = {
    strokeWidth: 0,
    fill: "#333",
    opacity: 1,
    rx: 0,
    ry: 0
  };

  function q(t) {
    var n = t.style,
        r = (t.opacity, t.x1),
        i = t.y1,
        o = t.x2,
        s = t.y2,
        c = h(t, ["style", "opacity", "x1", "y1", "x2", "y2"]),
        l = u({}, W, {}, n),
        f = Math.min(r, o),
        d = Math.min(i, s),
        y = Math.max(r, o),
        p = Math.max(i, s),
        g = Math.max(p - d, 0),
        m = Math.max(y - f, 0);
    return e.createElement("rect", a({}, c, {
      x: f,
      y: d,
      width: m,
      height: g,
      style: l
    }));
  }

  function X(t) {
    return function () {
      return t;
    };
  }

  function G(t) {
    return t[0];
  }

  function Z(t) {
    return t[1];
  }

  function $() {
    this._ = null;
  }

  function K(t) {
    t.U = t.C = t.L = t.R = t.P = t.N = null;
  }

  function J(t, e) {
    var n = e,
        r = e.R,
        i = n.U;
    i ? i.L === n ? i.L = r : i.R = r : t._ = r, r.U = i, n.U = r, n.R = r.L, n.R && (n.R.U = n), r.L = n;
  }

  function Q(t, e) {
    var n = e,
        r = e.L,
        i = n.U;
    i ? i.L === n ? i.L = r : i.R = r : t._ = r, r.U = i, n.U = r, n.L = r.R, n.L && (n.L.U = n), r.R = n;
  }

  function tt(t) {
    for (; t.L;) {
      t = t.L;
    }

    return t;
  }

  function et(t, e, n, r) {
    var i = [null, null],
        o = kt.push(i) - 1;
    return i.left = t, i.right = e, n && rt(i, t, e, n), r && rt(i, e, t, r), wt[t.index].halfedges.push(o), wt[e.index].halfedges.push(o), i;
  }

  function nt(t, e, n) {
    var r = [e, n];
    return r.left = t, r;
  }

  function rt(t, e, n, r) {
    t[0] || t[1] ? t.left === n ? t[1] = r : t[0] = r : (t[0] = r, t.left = e, t.right = n);
  }

  function it(t, e, n, r, i) {
    var o,
        a = t[0],
        s = t[1],
        u = a[0],
        c = a[1],
        l = 0,
        h = 1,
        f = s[0] - u,
        d = s[1] - c;

    if (o = e - u, f || !(o > 0)) {
      if (o /= f, f < 0) {
        if (o < l) return;
        o < h && (h = o);
      } else if (f > 0) {
        if (o > h) return;
        o > l && (l = o);
      }

      if (o = r - u, f || !(o < 0)) {
        if (o /= f, f < 0) {
          if (o > h) return;
          o > l && (l = o);
        } else if (f > 0) {
          if (o < l) return;
          o < h && (h = o);
        }

        if (o = n - c, d || !(o > 0)) {
          if (o /= d, d < 0) {
            if (o < l) return;
            o < h && (h = o);
          } else if (d > 0) {
            if (o > h) return;
            o > l && (l = o);
          }

          if (o = i - c, d || !(o < 0)) {
            if (o /= d, d < 0) {
              if (o > h) return;
              o > l && (l = o);
            } else if (d > 0) {
              if (o < l) return;
              o < h && (h = o);
            }

            return !(l > 0 || h < 1) || (l > 0 && (t[0] = [u + l * f, c + l * d]), h < 1 && (t[1] = [u + h * f, c + h * d]), !0);
          }
        }
      }
    }
  }

  function ot(t, e, n, r, i) {
    var o = t[1];
    if (o) return !0;
    var a,
        s,
        u = t[0],
        c = t.left,
        l = t.right,
        h = c[0],
        f = c[1],
        d = l[0],
        y = l[1],
        p = (h + d) / 2,
        g = (f + y) / 2;

    if (y === f) {
      if (p < e || p >= r) return;

      if (h > d) {
        if (u) {
          if (u[1] >= i) return;
        } else u = [p, n];

        o = [p, i];
      } else {
        if (u) {
          if (u[1] < n) return;
        } else u = [p, i];

        o = [p, n];
      }
    } else if (s = g - (a = (h - d) / (y - f)) * p, a < -1 || a > 1) {
      if (h > d) {
        if (u) {
          if (u[1] >= i) return;
        } else u = [(n - s) / a, n];

        o = [(i - s) / a, i];
      } else {
        if (u) {
          if (u[1] < n) return;
        } else u = [(i - s) / a, i];

        o = [(n - s) / a, n];
      }
    } else if (f < y) {
      if (u) {
        if (u[0] >= r) return;
      } else u = [e, a * e + s];

      o = [r, a * r + s];
    } else {
      if (u) {
        if (u[0] < e) return;
      } else u = [r, a * r + s];

      o = [e, a * e + s];
    }

    return t[0] = u, t[1] = o, !0;
  }

  function at(t, e) {
    var n = t.site,
        r = e.left,
        i = e.right;
    return n === i && (i = r, r = n), i ? Math.atan2(i[1] - r[1], i[0] - r[0]) : (n === r ? (r = e[1], i = e[0]) : (r = e[0], i = e[1]), Math.atan2(r[0] - i[0], i[1] - r[1]));
  }

  function st(t, e) {
    return e[+(e.left !== t.site)];
  }

  function ut(t, e) {
    return e[+(e.left === t.site)];
  }

  $.prototype = {
    constructor: $,
    insert: function insert(t, e) {
      var n, r, i;

      if (t) {
        if (e.P = t, e.N = t.N, t.N && (t.N.P = e), t.N = e, t.R) {
          for (t = t.R; t.L;) {
            t = t.L;
          }

          t.L = e;
        } else t.R = e;

        n = t;
      } else this._ ? (t = tt(this._), e.P = null, e.N = t, t.P = t.L = e, n = t) : (e.P = e.N = null, this._ = e, n = null);

      for (e.L = e.R = null, e.U = n, e.C = !0, t = e; n && n.C;) {
        n === (r = n.U).L ? (i = r.R) && i.C ? (n.C = i.C = !1, r.C = !0, t = r) : (t === n.R && (J(this, n), n = (t = n).U), n.C = !1, r.C = !0, Q(this, r)) : (i = r.L) && i.C ? (n.C = i.C = !1, r.C = !0, t = r) : (t === n.L && (Q(this, n), n = (t = n).U), n.C = !1, r.C = !0, J(this, r)), n = t.U;
      }

      this._.C = !1;
    },
    remove: function remove(t) {
      t.N && (t.N.P = t.P), t.P && (t.P.N = t.N), t.N = t.P = null;
      var e,
          n,
          r,
          i = t.U,
          o = t.L,
          a = t.R;
      if (n = o ? a ? tt(a) : o : a, i ? i.L === t ? i.L = n : i.R = n : this._ = n, o && a ? (r = n.C, n.C = t.C, n.L = o, o.U = n, n !== a ? (i = n.U, n.U = t.U, t = n.R, i.L = t, n.R = a, a.U = n) : (n.U = i, i = n, t = n.R)) : (r = t.C, t = n), t && (t.U = i), !r) if (t && t.C) t.C = !1;else {
        do {
          if (t === this._) break;

          if (t === i.L) {
            if ((e = i.R).C && (e.C = !1, i.C = !0, J(this, i), e = i.R), e.L && e.L.C || e.R && e.R.C) {
              e.R && e.R.C || (e.L.C = !1, e.C = !0, Q(this, e), e = i.R), e.C = i.C, i.C = e.R.C = !1, J(this, i), t = this._;
              break;
            }
          } else if ((e = i.L).C && (e.C = !1, i.C = !0, Q(this, i), e = i.L), e.L && e.L.C || e.R && e.R.C) {
            e.L && e.L.C || (e.R.C = !1, e.C = !0, J(this, e), e = i.L), e.C = i.C, i.C = e.L.C = !1, Q(this, i), t = this._;
            break;
          }

          e.C = !0, t = i, i = i.U;
        } while (!t.C);

        t && (t.C = !1);
      }
    }
  };
  var ct,
      lt = [];

  function ht() {
    K(this), this.x = this.y = this.arc = this.site = this.cy = null;
  }

  function ft(t) {
    var e = t.P,
        n = t.N;

    if (e && n) {
      var r = e.site,
          i = t.site,
          o = n.site;

      if (r !== o) {
        var a = i[0],
            s = i[1],
            u = r[0] - a,
            c = r[1] - s,
            l = o[0] - a,
            h = o[1] - s,
            f = 2 * (u * h - c * l);

        if (!(f >= -At)) {
          var d = u * u + c * c,
              y = l * l + h * h,
              p = (h * d - c * y) / f,
              g = (u * y - l * d) / f,
              m = lt.pop() || new ht();
          m.arc = t, m.site = i, m.x = p + a, m.y = (m.cy = g + s) + Math.sqrt(p * p + g * g), t.circle = m;

          for (var _ = null, x = Ct._; x;) {
            if (m.y < x.y || m.y === x.y && m.x <= x.x) {
              if (!x.L) {
                _ = x.P;
                break;
              }

              x = x.L;
            } else {
              if (!x.R) {
                _ = x;
                break;
              }

              x = x.R;
            }
          }

          Ct.insert(_, m), _ || (ct = m);
        }
      }
    }
  }

  function dt(t) {
    var e = t.circle;
    e && (e.P || (ct = e.N), Ct.remove(e), lt.push(e), K(e), t.circle = null);
  }

  var yt = [];

  function pt() {
    K(this), this.edge = this.site = this.circle = null;
  }

  function gt(t) {
    var e = yt.pop() || new pt();
    return e.site = t, e;
  }

  function mt(t) {
    dt(t), Mt.remove(t), yt.push(t), K(t);
  }

  function _t(t) {
    var e = t.circle,
        n = e.x,
        r = e.cy,
        i = [n, r],
        o = t.P,
        a = t.N,
        s = [t];
    mt(t);

    for (var u = o; u.circle && Math.abs(n - u.circle.x) < St && Math.abs(r - u.circle.cy) < St;) {
      o = u.P, s.unshift(u), mt(u), u = o;
    }

    s.unshift(u), dt(u);

    for (var c = a; c.circle && Math.abs(n - c.circle.x) < St && Math.abs(r - c.circle.cy) < St;) {
      a = c.N, s.push(c), mt(c), c = a;
    }

    s.push(c), dt(c);
    var l,
        h = s.length;

    for (l = 1; l < h; ++l) {
      c = s[l], u = s[l - 1], rt(c.edge, u.site, c.site, i);
    }

    u = s[0], (c = s[h - 1]).edge = et(u.site, c.site, null, i), ft(u), ft(c);
  }

  function xt(t) {
    for (var e, n, r, i, o = t[0], a = t[1], s = Mt._; s;) {
      if ((r = vt(s, a) - o) > St) s = s.L;else {
        if (!((i = o - bt(s, a)) > St)) {
          r > -St ? (e = s.P, n = s) : i > -St ? (e = s, n = s.N) : e = n = s;
          break;
        }

        if (!s.R) {
          e = s;
          break;
        }

        s = s.R;
      }
    }

    !function (t) {
      wt[t.index] = {
        site: t,
        halfedges: []
      };
    }(t);
    var u = gt(t);

    if (Mt.insert(e, u), e || n) {
      if (e === n) return dt(e), n = gt(e.site), Mt.insert(u, n), u.edge = n.edge = et(e.site, u.site), ft(e), void ft(n);

      if (n) {
        dt(e), dt(n);

        var c = e.site,
            l = c[0],
            h = c[1],
            f = t[0] - l,
            d = t[1] - h,
            y = n.site,
            p = y[0] - l,
            g = y[1] - h,
            m = 2 * (f * g - d * p),
            _ = f * f + d * d,
            x = p * p + g * g,
            v = [(g * _ - d * x) / m + l, (f * x - p * _) / m + h];

        rt(n.edge, c, y, v), u.edge = et(c, t, null, v), n.edge = et(t, y, null, v), ft(e), ft(n);
      } else u.edge = et(e.site, u.site);
    }
  }

  function vt(t, e) {
    var n = t.site,
        r = n[0],
        i = n[1],
        o = i - e;
    if (!o) return r;
    var a = t.P;
    if (!a) return -1 / 0;
    var s = (n = a.site)[0],
        u = n[1],
        c = u - e;
    if (!c) return s;
    var l = s - r,
        h = 1 / o - 1 / c,
        f = l / c;
    return h ? (-f + Math.sqrt(f * f - 2 * h * (l * l / (-2 * c) - u + c / 2 + i - o / 2))) / h + r : (r + s) / 2;
  }

  function bt(t, e) {
    var n = t.N;
    if (n) return vt(n, e);
    var r = t.site;
    return r[1] === e ? r[0] : 1 / 0;
  }

  var Mt,
      wt,
      Ct,
      kt,
      St = 1e-6,
      At = 1e-12;

  function Et(t, e) {
    return e[1] - t[1] || e[0] - t[0];
  }

  function Tt(t, e) {
    var n,
        r,
        i,
        o = t.sort(Et).pop();

    for (kt = [], wt = new Array(t.length), Mt = new $(), Ct = new $();;) {
      if (i = ct, o && (!i || o[1] < i.y || o[1] === i.y && o[0] < i.x)) o[0] === n && o[1] === r || (xt(o), n = o[0], r = o[1]), o = t.pop();else {
        if (!i) break;

        _t(i.arc);
      }
    }

    if (function () {
      for (var t, e, n, r, i = 0, o = wt.length; i < o; ++i) {
        if ((t = wt[i]) && (r = (e = t.halfedges).length)) {
          var a = new Array(r),
              s = new Array(r);

          for (n = 0; n < r; ++n) {
            a[n] = n, s[n] = at(t, kt[e[n]]);
          }

          for (a.sort(function (t, e) {
            return s[e] - s[t];
          }), n = 0; n < r; ++n) {
            s[n] = e[a[n]];
          }

          for (n = 0; n < r; ++n) {
            e[n] = s[n];
          }
        }
      }
    }(), e) {
      var a = +e[0][0],
          s = +e[0][1],
          u = +e[1][0],
          c = +e[1][1];
      !function (t, e, n, r) {
        for (var i, o = kt.length; o--;) {
          ot(i = kt[o], t, e, n, r) && it(i, t, e, n, r) && (Math.abs(i[0][0] - i[1][0]) > St || Math.abs(i[0][1] - i[1][1]) > St) || delete kt[o];
        }
      }(a, s, u, c), function (t, e, n, r) {
        var i,
            o,
            a,
            s,
            u,
            c,
            l,
            h,
            f,
            d,
            y,
            p,
            g = wt.length,
            m = !0;

        for (i = 0; i < g; ++i) {
          if (o = wt[i]) {
            for (a = o.site, s = (u = o.halfedges).length; s--;) {
              kt[u[s]] || u.splice(s, 1);
            }

            for (s = 0, c = u.length; s < c;) {
              y = (d = ut(o, kt[u[s]]))[0], p = d[1], h = (l = st(o, kt[u[++s % c]]))[0], f = l[1], (Math.abs(y - h) > St || Math.abs(p - f) > St) && (u.splice(s, 0, kt.push(nt(a, d, Math.abs(y - t) < St && r - p > St ? [t, Math.abs(h - t) < St ? f : r] : Math.abs(p - r) < St && n - y > St ? [Math.abs(f - r) < St ? h : n, r] : Math.abs(y - n) < St && p - e > St ? [n, Math.abs(h - n) < St ? f : e] : Math.abs(p - e) < St && y - t > St ? [Math.abs(f - e) < St ? h : t, e] : null)) - 1), ++c);
            }

            c && (m = !1);
          }
        }

        if (m) {
          var _,
              x,
              v,
              b = 1 / 0;

          for (i = 0, m = null; i < g; ++i) {
            (o = wt[i]) && (v = (_ = (a = o.site)[0] - t) * _ + (x = a[1] - e) * x) < b && (b = v, m = o);
          }

          if (m) {
            var M = [t, e],
                w = [t, r],
                C = [n, r],
                k = [n, e];
            m.halfedges.push(kt.push(nt(a = m.site, M, w)) - 1, kt.push(nt(a, w, C)) - 1, kt.push(nt(a, C, k)) - 1, kt.push(nt(a, k, M)) - 1);
          }
        }

        for (i = 0; i < g; ++i) {
          (o = wt[i]) && (o.halfedges.length || delete wt[i]);
        }
      }(a, s, u, c);
    }

    this.edges = kt, this.cells = wt, Mt = Ct = kt = wt = null;
  }

  function Dt(t, e) {
    return t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
  }

  function Nt(t) {
    var e;
    return 1 === t.length && (e = t, t = function t(_t2, n) {
      return Dt(e(_t2), n);
    }), {
      left: function left(e, n, r, i) {
        for (null == r && (r = 0), null == i && (i = e.length); r < i;) {
          var o = r + i >>> 1;
          t(e[o], n) < 0 ? r = o + 1 : i = o;
        }

        return r;
      },
      right: function right(e, n, r, i) {
        for (null == r && (r = 0), null == i && (i = e.length); r < i;) {
          var o = r + i >>> 1;
          t(e[o], n) > 0 ? i = o : r = o + 1;
        }

        return r;
      }
    };
  }

  Tt.prototype = {
    constructor: Tt,
    polygons: function polygons() {
      var t = this.edges;
      return this.cells.map(function (e) {
        var n = e.halfedges.map(function (n) {
          return st(e, t[n]);
        });
        return n.data = e.site.data, n;
      });
    },
    triangles: function triangles() {
      var t = [],
          e = this.edges;
      return this.cells.forEach(function (n, r) {
        if (o = (i = n.halfedges).length) for (var i, o, a, s, u, c, l = n.site, h = -1, f = e[i[o - 1]], d = f.left === l ? f.right : f.left; ++h < o;) {
          a = d, d = (f = e[i[h]]).left === l ? f.right : f.left, a && d && r < a.index && r < d.index && (u = a, c = d, ((s = l)[0] - c[0]) * (u[1] - s[1]) - (s[0] - u[0]) * (c[1] - s[1]) < 0) && t.push([l.data, a.data, d.data]);
        }
      }), t;
    },
    links: function links() {
      return this.edges.filter(function (t) {
        return t.right;
      }).map(function (t) {
        return {
          source: t.left.data,
          target: t.right.data
        };
      });
    },
    find: function find(t, e, n) {
      for (var r, i, o = this, a = o._found || 0, s = o.cells.length; !(i = o.cells[a]);) {
        if (++a >= s) return null;
      }

      var u = t - i.site[0],
          c = e - i.site[1],
          l = u * u + c * c;

      do {
        i = o.cells[r = a], a = null, i.halfedges.forEach(function (n) {
          var r = o.edges[n],
              s = r.left;

          if (s !== i.site && s || (s = r.right)) {
            var u = t - s[0],
                c = e - s[1],
                h = u * u + c * c;
            h < l && (l = h, a = s.index);
          }
        });
      } while (null !== a);

      return o._found = r, null == n || l <= n * n ? i.site : null;
    }
  };
  var Rt = Nt(Dt).right;

  function Lt(t, e, n) {
    t = +t, e = +e, n = (i = arguments.length) < 2 ? (e = t, t = 0, 1) : i < 3 ? 1 : +n;

    for (var r = -1, i = 0 | Math.max(0, Math.ceil((e - t) / n)), o = new Array(i); ++r < i;) {
      o[r] = t + r * n;
    }

    return o;
  }

  var Pt = Math.sqrt(50),
      Ot = Math.sqrt(10),
      Ut = Math.sqrt(2);

  function It(t, e, n) {
    var r,
        i,
        o,
        a,
        s = -1;
    if (n = +n, (t = +t) == (e = +e) && n > 0) return [t];
    if ((r = e < t) && (i = t, t = e, e = i), 0 === (a = Vt(t, e, n)) || !isFinite(a)) return [];
    if (a > 0) for (t = Math.ceil(t / a), e = Math.floor(e / a), o = new Array(i = Math.ceil(e - t + 1)); ++s < i;) {
      o[s] = (t + s) * a;
    } else for (t = Math.floor(t * a), e = Math.ceil(e * a), o = new Array(i = Math.ceil(t - e + 1)); ++s < i;) {
      o[s] = (t - s) / a;
    }
    return r && o.reverse(), o;
  }

  function Vt(t, e, n) {
    var r = (e - t) / Math.max(0, n),
        i = Math.floor(Math.log(r) / Math.LN10),
        o = r / Math.pow(10, i);
    return i >= 0 ? (o >= Pt ? 10 : o >= Ot ? 5 : o >= Ut ? 2 : 1) * Math.pow(10, i) : -Math.pow(10, -i) / (o >= Pt ? 10 : o >= Ot ? 5 : o >= Ut ? 2 : 1);
  }

  function zt(t, e, n) {
    var r = Math.abs(e - t) / Math.max(0, n),
        i = Math.pow(10, Math.floor(Math.log(r) / Math.LN10)),
        o = r / i;
    return o >= Pt ? i *= 10 : o >= Ot ? i *= 5 : o >= Ut && (i *= 2), e < t ? -i : i;
  }

  function jt(t, e) {
    switch (arguments.length) {
      case 0:
        break;

      case 1:
        this.range(t);
        break;

      default:
        this.range(e).domain(t);
    }

    return this;
  }

  var Ft = Symbol("implicit");

  function Bt() {
    var t = new Map(),
        e = [],
        n = [],
        r = Ft;

    function i(i) {
      var o = i + "",
          a = t.get(o);

      if (!a) {
        if (r !== Ft) return r;
        t.set(o, a = e.push(i));
      }

      return n[(a - 1) % n.length];
    }

    return i.domain = function (n) {
      if (!arguments.length) return e.slice();
      e = [], t = new Map();

      var r,
          o = _(n);

      try {
        for (o.s(); !(r = o.n()).done;) {
          var a = r.value,
              s = a + "";
          t.has(s) || t.set(s, e.push(a));
        }
      } catch (t) {
        o.e(t);
      } finally {
        o.f();
      }

      return i;
    }, i.range = function (t) {
      return arguments.length ? (n = Array.from(t), i) : n.slice();
    }, i.unknown = function (t) {
      return arguments.length ? (r = t, i) : r;
    }, i.copy = function () {
      return Bt(e, n).unknown(r);
    }, jt.apply(i, arguments), i;
  }

  function Ht() {
    var t,
        e,
        n = Bt().unknown(void 0),
        r = n.domain,
        i = n.range,
        o = 0,
        a = 1,
        s = !1,
        u = 0,
        c = 0,
        l = .5;

    function h() {
      var n = r().length,
          h = a < o,
          f = h ? a : o,
          d = h ? o : a;
      t = (d - f) / Math.max(1, n - u + 2 * c), s && (t = Math.floor(t)), f += (d - f - t * (n - u)) * l, e = t * (1 - u), s && (f = Math.round(f), e = Math.round(e));
      var y = Lt(n).map(function (e) {
        return f + t * e;
      });
      return i(h ? y.reverse() : y);
    }

    return delete n.unknown, n.domain = function (t) {
      return arguments.length ? (r(t), h()) : r();
    }, n.range = function (t) {
      var e;
      return arguments.length ? (e = y(t, 2), o = e[0], a = e[1], o = +o, a = +a, h()) : [o, a];
    }, n.rangeRound = function (t) {
      var e;
      return e = y(t, 2), o = e[0], a = e[1], o = +o, a = +a, s = !0, h();
    }, n.bandwidth = function () {
      return e;
    }, n.step = function () {
      return t;
    }, n.round = function (t) {
      return arguments.length ? (s = !!t, h()) : s;
    }, n.padding = function (t) {
      return arguments.length ? (u = Math.min(1, c = +t), h()) : u;
    }, n.paddingInner = function (t) {
      return arguments.length ? (u = Math.min(1, t), h()) : u;
    }, n.paddingOuter = function (t) {
      return arguments.length ? (c = +t, h()) : c;
    }, n.align = function (t) {
      return arguments.length ? (l = Math.max(0, Math.min(1, t)), h()) : l;
    }, n.copy = function () {
      return Ht(r(), [o, a]).round(s).paddingInner(u).paddingOuter(c).align(l);
    }, jt.apply(h(), arguments);
  }

  function Yt(t, e, n) {
    t.prototype = e.prototype = n, n.constructor = t;
  }

  function Wt(t, e) {
    var n = Object.create(t.prototype);

    for (var r in e) {
      n[r] = e[r];
    }

    return n;
  }

  function qt() {}

  var Xt = "\\s*([+-]?\\d+)\\s*",
      Gt = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
      Zt = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
      $t = /^#([0-9a-f]{3,8})$/,
      Kt = new RegExp("^rgb\\(" + [Xt, Xt, Xt] + "\\)$"),
      Jt = new RegExp("^rgb\\(" + [Zt, Zt, Zt] + "\\)$"),
      Qt = new RegExp("^rgba\\(" + [Xt, Xt, Xt, Gt] + "\\)$"),
      te = new RegExp("^rgba\\(" + [Zt, Zt, Zt, Gt] + "\\)$"),
      ee = new RegExp("^hsl\\(" + [Gt, Zt, Zt] + "\\)$"),
      ne = new RegExp("^hsla\\(" + [Gt, Zt, Zt, Gt] + "\\)$"),
      re = {
    aliceblue: 15792383,
    antiquewhite: 16444375,
    aqua: 65535,
    aquamarine: 8388564,
    azure: 15794175,
    beige: 16119260,
    bisque: 16770244,
    black: 0,
    blanchedalmond: 16772045,
    blue: 255,
    blueviolet: 9055202,
    brown: 10824234,
    burlywood: 14596231,
    cadetblue: 6266528,
    chartreuse: 8388352,
    chocolate: 13789470,
    coral: 16744272,
    cornflowerblue: 6591981,
    cornsilk: 16775388,
    crimson: 14423100,
    cyan: 65535,
    darkblue: 139,
    darkcyan: 35723,
    darkgoldenrod: 12092939,
    darkgray: 11119017,
    darkgreen: 25600,
    darkgrey: 11119017,
    darkkhaki: 12433259,
    darkmagenta: 9109643,
    darkolivegreen: 5597999,
    darkorange: 16747520,
    darkorchid: 10040012,
    darkred: 9109504,
    darksalmon: 15308410,
    darkseagreen: 9419919,
    darkslateblue: 4734347,
    darkslategray: 3100495,
    darkslategrey: 3100495,
    darkturquoise: 52945,
    darkviolet: 9699539,
    deeppink: 16716947,
    deepskyblue: 49151,
    dimgray: 6908265,
    dimgrey: 6908265,
    dodgerblue: 2003199,
    firebrick: 11674146,
    floralwhite: 16775920,
    forestgreen: 2263842,
    fuchsia: 16711935,
    gainsboro: 14474460,
    ghostwhite: 16316671,
    gold: 16766720,
    goldenrod: 14329120,
    gray: 8421504,
    green: 32768,
    greenyellow: 11403055,
    grey: 8421504,
    honeydew: 15794160,
    hotpink: 16738740,
    indianred: 13458524,
    indigo: 4915330,
    ivory: 16777200,
    khaki: 15787660,
    lavender: 15132410,
    lavenderblush: 16773365,
    lawngreen: 8190976,
    lemonchiffon: 16775885,
    lightblue: 11393254,
    lightcoral: 15761536,
    lightcyan: 14745599,
    lightgoldenrodyellow: 16448210,
    lightgray: 13882323,
    lightgreen: 9498256,
    lightgrey: 13882323,
    lightpink: 16758465,
    lightsalmon: 16752762,
    lightseagreen: 2142890,
    lightskyblue: 8900346,
    lightslategray: 7833753,
    lightslategrey: 7833753,
    lightsteelblue: 11584734,
    lightyellow: 16777184,
    lime: 65280,
    limegreen: 3329330,
    linen: 16445670,
    magenta: 16711935,
    maroon: 8388608,
    mediumaquamarine: 6737322,
    mediumblue: 205,
    mediumorchid: 12211667,
    mediumpurple: 9662683,
    mediumseagreen: 3978097,
    mediumslateblue: 8087790,
    mediumspringgreen: 64154,
    mediumturquoise: 4772300,
    mediumvioletred: 13047173,
    midnightblue: 1644912,
    mintcream: 16121850,
    mistyrose: 16770273,
    moccasin: 16770229,
    navajowhite: 16768685,
    navy: 128,
    oldlace: 16643558,
    olive: 8421376,
    olivedrab: 7048739,
    orange: 16753920,
    orangered: 16729344,
    orchid: 14315734,
    palegoldenrod: 15657130,
    palegreen: 10025880,
    paleturquoise: 11529966,
    palevioletred: 14381203,
    papayawhip: 16773077,
    peachpuff: 16767673,
    peru: 13468991,
    pink: 16761035,
    plum: 14524637,
    powderblue: 11591910,
    purple: 8388736,
    rebeccapurple: 6697881,
    red: 16711680,
    rosybrown: 12357519,
    royalblue: 4286945,
    saddlebrown: 9127187,
    salmon: 16416882,
    sandybrown: 16032864,
    seagreen: 3050327,
    seashell: 16774638,
    sienna: 10506797,
    silver: 12632256,
    skyblue: 8900331,
    slateblue: 6970061,
    slategray: 7372944,
    slategrey: 7372944,
    snow: 16775930,
    springgreen: 65407,
    steelblue: 4620980,
    tan: 13808780,
    teal: 32896,
    thistle: 14204888,
    tomato: 16737095,
    turquoise: 4251856,
    violet: 15631086,
    wheat: 16113331,
    white: 16777215,
    whitesmoke: 16119285,
    yellow: 16776960,
    yellowgreen: 10145074
  };

  function ie() {
    return this.rgb().formatHex();
  }

  function oe() {
    return this.rgb().formatRgb();
  }

  function ae(t) {
    var e, n;
    return t = (t + "").trim().toLowerCase(), (e = $t.exec(t)) ? (n = e[1].length, e = parseInt(e[1], 16), 6 === n ? se(e) : 3 === n ? new he(e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | 240 & e, (15 & e) << 4 | 15 & e, 1) : 8 === n ? new he(e >> 24 & 255, e >> 16 & 255, e >> 8 & 255, (255 & e) / 255) : 4 === n ? new he(e >> 12 & 15 | e >> 8 & 240, e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | 240 & e, ((15 & e) << 4 | 15 & e) / 255) : null) : (e = Kt.exec(t)) ? new he(e[1], e[2], e[3], 1) : (e = Jt.exec(t)) ? new he(255 * e[1] / 100, 255 * e[2] / 100, 255 * e[3] / 100, 1) : (e = Qt.exec(t)) ? ue(e[1], e[2], e[3], e[4]) : (e = te.exec(t)) ? ue(255 * e[1] / 100, 255 * e[2] / 100, 255 * e[3] / 100, e[4]) : (e = ee.exec(t)) ? pe(e[1], e[2] / 100, e[3] / 100, 1) : (e = ne.exec(t)) ? pe(e[1], e[2] / 100, e[3] / 100, e[4]) : re.hasOwnProperty(t) ? se(re[t]) : "transparent" === t ? new he(NaN, NaN, NaN, 0) : null;
  }

  function se(t) {
    return new he(t >> 16 & 255, t >> 8 & 255, 255 & t, 1);
  }

  function ue(t, e, n, r) {
    return r <= 0 && (t = e = n = NaN), new he(t, e, n, r);
  }

  function ce(t) {
    return t instanceof qt || (t = ae(t)), t ? new he((t = t.rgb()).r, t.g, t.b, t.opacity) : new he();
  }

  function le(t, e, n, r) {
    return 1 === arguments.length ? ce(t) : new he(t, e, n, null == r ? 1 : r);
  }

  function he(t, e, n, r) {
    this.r = +t, this.g = +e, this.b = +n, this.opacity = +r;
  }

  function fe() {
    return "#" + ye(this.r) + ye(this.g) + ye(this.b);
  }

  function de() {
    var t = this.opacity;
    return (1 === (t = isNaN(t) ? 1 : Math.max(0, Math.min(1, t))) ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (1 === t ? ")" : ", " + t + ")");
  }

  function ye(t) {
    return ((t = Math.max(0, Math.min(255, Math.round(t) || 0))) < 16 ? "0" : "") + t.toString(16);
  }

  function pe(t, e, n, r) {
    return r <= 0 ? t = e = n = NaN : n <= 0 || n >= 1 ? t = e = NaN : e <= 0 && (t = NaN), new me(t, e, n, r);
  }

  function ge(t) {
    if (t instanceof me) return new me(t.h, t.s, t.l, t.opacity);
    if (t instanceof qt || (t = ae(t)), !t) return new me();
    if (t instanceof me) return t;
    var e = (t = t.rgb()).r / 255,
        n = t.g / 255,
        r = t.b / 255,
        i = Math.min(e, n, r),
        o = Math.max(e, n, r),
        a = NaN,
        s = o - i,
        u = (o + i) / 2;
    return s ? (a = e === o ? (n - r) / s + 6 * (n < r) : n === o ? (r - e) / s + 2 : (e - n) / s + 4, s /= u < .5 ? o + i : 2 - o - i, a *= 60) : s = u > 0 && u < 1 ? 0 : a, new me(a, s, u, t.opacity);
  }

  function me(t, e, n, r) {
    this.h = +t, this.s = +e, this.l = +n, this.opacity = +r;
  }

  function _e(t, e, n) {
    return 255 * (t < 60 ? e + (n - e) * t / 60 : t < 180 ? n : t < 240 ? e + (n - e) * (240 - t) / 60 : e);
  }

  function xe(t) {
    return function () {
      return t;
    };
  }

  function ve(t, e) {
    var n = e - t;
    return n ? function (t, e) {
      return function (n) {
        return t + n * e;
      };
    }(t, n) : xe(isNaN(t) ? e : t);
  }

  Yt(qt, ae, {
    copy: function copy(t) {
      return Object.assign(new this.constructor(), this, t);
    },
    displayable: function displayable() {
      return this.rgb().displayable();
    },
    hex: ie,
    formatHex: ie,
    formatHsl: function formatHsl() {
      return ge(this).formatHsl();
    },
    formatRgb: oe,
    toString: oe
  }), Yt(he, le, Wt(qt, {
    brighter: function brighter(t) {
      return t = null == t ? 1 / .7 : Math.pow(1 / .7, t), new he(this.r * t, this.g * t, this.b * t, this.opacity);
    },
    darker: function darker(t) {
      return t = null == t ? .7 : Math.pow(.7, t), new he(this.r * t, this.g * t, this.b * t, this.opacity);
    },
    rgb: function rgb() {
      return this;
    },
    displayable: function displayable() {
      return -.5 <= this.r && this.r < 255.5 && -.5 <= this.g && this.g < 255.5 && -.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: fe,
    formatHex: fe,
    formatRgb: de,
    toString: de
  })), Yt(me, function (t, e, n, r) {
    return 1 === arguments.length ? ge(t) : new me(t, e, n, null == r ? 1 : r);
  }, Wt(qt, {
    brighter: function brighter(t) {
      return t = null == t ? 1 / .7 : Math.pow(1 / .7, t), new me(this.h, this.s, this.l * t, this.opacity);
    },
    darker: function darker(t) {
      return t = null == t ? .7 : Math.pow(.7, t), new me(this.h, this.s, this.l * t, this.opacity);
    },
    rgb: function rgb() {
      var t = this.h % 360 + 360 * (this.h < 0),
          e = isNaN(t) || isNaN(this.s) ? 0 : this.s,
          n = this.l,
          r = n + (n < .5 ? n : 1 - n) * e,
          i = 2 * n - r;
      return new he(_e(t >= 240 ? t - 240 : t + 120, i, r), _e(t, i, r), _e(t < 120 ? t + 240 : t - 120, i, r), this.opacity);
    },
    displayable: function displayable() {
      return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl: function formatHsl() {
      var t = this.opacity;
      return (1 === (t = isNaN(t) ? 1 : Math.max(0, Math.min(1, t))) ? "hsl(" : "hsla(") + (this.h || 0) + ", " + 100 * (this.s || 0) + "%, " + 100 * (this.l || 0) + "%" + (1 === t ? ")" : ", " + t + ")");
    }
  }));

  var be = function t(e) {
    var n = function (t) {
      return 1 == (t = +t) ? ve : function (e, n) {
        return n - e ? function (t, e, n) {
          return t = Math.pow(t, n), e = Math.pow(e, n) - t, n = 1 / n, function (r) {
            return Math.pow(t + r * e, n);
          };
        }(e, n, t) : xe(isNaN(e) ? n : e);
      };
    }(e);

    function r(t, e) {
      var r = n((t = le(t)).r, (e = le(e)).r),
          i = n(t.g, e.g),
          o = n(t.b, e.b),
          a = ve(t.opacity, e.opacity);
      return function (e) {
        return t.r = r(e), t.g = i(e), t.b = o(e), t.opacity = a(e), t + "";
      };
    }

    return r.gamma = t, r;
  }(1);

  function Me(t, e) {
    e || (e = []);
    var n,
        r = t ? Math.min(e.length, t.length) : 0,
        i = e.slice();
    return function (o) {
      for (n = 0; n < r; ++n) {
        i[n] = t[n] * (1 - o) + e[n] * o;
      }

      return i;
    };
  }

  function we(t, e) {
    var n,
        r = e ? e.length : 0,
        i = t ? Math.min(r, t.length) : 0,
        o = new Array(i),
        a = new Array(r);

    for (n = 0; n < i; ++n) {
      o[n] = De(t[n], e[n]);
    }

    for (; n < r; ++n) {
      a[n] = e[n];
    }

    return function (t) {
      for (n = 0; n < i; ++n) {
        a[n] = o[n](t);
      }

      return a;
    };
  }

  function Ce(t, e) {
    var n = new Date();
    return t = +t, e = +e, function (r) {
      return n.setTime(t * (1 - r) + e * r), n;
    };
  }

  function ke(t, e) {
    return t = +t, e = +e, function (n) {
      return t * (1 - n) + e * n;
    };
  }

  function Se(t, e) {
    var r,
        i = {},
        o = {};

    for (r in null !== t && "object" == n(t) || (t = {}), null !== e && "object" == n(e) || (e = {}), e) {
      r in t ? i[r] = De(t[r], e[r]) : o[r] = e[r];
    }

    return function (t) {
      for (r in i) {
        o[r] = i[r](t);
      }

      return o;
    };
  }

  var Ae = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
      Ee = new RegExp(Ae.source, "g");

  function Te(t, e) {
    var n,
        r,
        i,
        o = Ae.lastIndex = Ee.lastIndex = 0,
        a = -1,
        s = [],
        u = [];

    for (t += "", e += ""; (n = Ae.exec(t)) && (r = Ee.exec(e));) {
      (i = r.index) > o && (i = e.slice(o, i), s[a] ? s[a] += i : s[++a] = i), (n = n[0]) === (r = r[0]) ? s[a] ? s[a] += r : s[++a] = r : (s[++a] = null, u.push({
        i: a,
        x: ke(n, r)
      })), o = Ee.lastIndex;
    }

    return o < e.length && (i = e.slice(o), s[a] ? s[a] += i : s[++a] = i), s.length < 2 ? u[0] ? function (t) {
      return function (e) {
        return t(e) + "";
      };
    }(u[0].x) : function (t) {
      return function () {
        return t;
      };
    }(e) : (e = u.length, function (t) {
      for (var n, r = 0; r < e; ++r) {
        s[(n = u[r]).i] = n.x(t);
      }

      return s.join("");
    });
  }

  function De(t, e) {
    var r,
        i = n(e);
    return null == e || "boolean" === i ? xe(e) : ("number" === i ? ke : "string" === i ? (r = ae(e)) ? (e = r, be) : Te : e instanceof ae ? be : e instanceof Date ? Ce : function (t) {
      return ArrayBuffer.isView(t) && !(t instanceof DataView);
    }(e) ? Me : Array.isArray(e) ? we : "function" != typeof e.valueOf && "function" != typeof e.toString || isNaN(e) ? Se : ke)(t, e);
  }

  function Ne(t, e) {
    return t = +t, e = +e, function (n) {
      return Math.round(t * (1 - n) + e * n);
    };
  }

  function Re(t) {
    return +t;
  }

  var Le = [0, 1];

  function Pe(t) {
    return t;
  }

  function Oe(t, e) {
    return (e -= t = +t) ? function (n) {
      return (n - t) / e;
    } : function (t) {
      return function () {
        return t;
      };
    }(isNaN(e) ? NaN : .5);
  }

  function Ue(t, e, n) {
    var r = t[0],
        i = t[1],
        o = e[0],
        a = e[1];
    return i < r ? (r = Oe(i, r), o = n(a, o)) : (r = Oe(r, i), o = n(o, a)), function (t) {
      return o(r(t));
    };
  }

  function Ie(t, e, n) {
    var r = Math.min(t.length, e.length) - 1,
        i = new Array(r),
        o = new Array(r),
        a = -1;

    for (t[r] < t[0] && (t = t.slice().reverse(), e = e.slice().reverse()); ++a < r;) {
      i[a] = Oe(t[a], t[a + 1]), o[a] = n(e[a], e[a + 1]);
    }

    return function (e) {
      var n = Rt(t, e, 1, r) - 1;
      return o[n](i[n](e));
    };
  }

  function Ve(t, e) {
    return e.domain(t.domain()).range(t.range()).interpolate(t.interpolate()).clamp(t.clamp()).unknown(t.unknown());
  }

  function ze() {
    var t,
        e,
        n,
        r,
        i,
        o,
        a = Le,
        s = Le,
        u = De,
        c = Pe;

    function l() {
      var t,
          e,
          n,
          u = Math.min(a.length, s.length);
      return c !== Pe && (t = a[0], e = a[u - 1], t > e && (n = t, t = e, e = n), c = function c(n) {
        return Math.max(t, Math.min(e, n));
      }), r = u > 2 ? Ie : Ue, i = o = null, h;
    }

    function h(e) {
      return isNaN(e = +e) ? n : (i || (i = r(a.map(t), s, u)))(t(c(e)));
    }

    return h.invert = function (n) {
      return c(e((o || (o = r(s, a.map(t), ke)))(n)));
    }, h.domain = function (t) {
      return arguments.length ? (a = Array.from(t, Re), l()) : a.slice();
    }, h.range = function (t) {
      return arguments.length ? (s = Array.from(t), l()) : s.slice();
    }, h.rangeRound = function (t) {
      return s = Array.from(t), u = Ne, l();
    }, h.clamp = function (t) {
      return arguments.length ? (c = !!t || Pe, l()) : c !== Pe;
    }, h.interpolate = function (t) {
      return arguments.length ? (u = t, l()) : u;
    }, h.unknown = function (t) {
      return arguments.length ? (n = t, h) : n;
    }, function (n, r) {
      return t = n, e = r, l();
    };
  }

  function je() {
    return ze()(Pe, Pe);
  }

  function Fe(t, e) {
    if ((n = (t = e ? t.toExponential(e - 1) : t.toExponential()).indexOf("e")) < 0) return null;
    var n,
        r = t.slice(0, n);
    return [r.length > 1 ? r[0] + r.slice(2) : r, +t.slice(n + 1)];
  }

  function Be(t) {
    return (t = Fe(Math.abs(t))) ? t[1] : NaN;
  }

  var He,
      Ye = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;

  function We(t) {
    if (!(e = Ye.exec(t))) throw new Error("invalid format: " + t);
    var e;
    return new qe({
      fill: e[1],
      align: e[2],
      sign: e[3],
      symbol: e[4],
      zero: e[5],
      width: e[6],
      comma: e[7],
      precision: e[8] && e[8].slice(1),
      trim: e[9],
      type: e[10]
    });
  }

  function qe(t) {
    this.fill = void 0 === t.fill ? " " : t.fill + "", this.align = void 0 === t.align ? ">" : t.align + "", this.sign = void 0 === t.sign ? "-" : t.sign + "", this.symbol = void 0 === t.symbol ? "" : t.symbol + "", this.zero = !!t.zero, this.width = void 0 === t.width ? void 0 : +t.width, this.comma = !!t.comma, this.precision = void 0 === t.precision ? void 0 : +t.precision, this.trim = !!t.trim, this.type = void 0 === t.type ? "" : t.type + "";
  }

  function Xe(t, e) {
    var n = Fe(t, e);
    if (!n) return t + "";
    var r = n[0],
        i = n[1];
    return i < 0 ? "0." + new Array(-i).join("0") + r : r.length > i + 1 ? r.slice(0, i + 1) + "." + r.slice(i + 1) : r + new Array(i - r.length + 2).join("0");
  }

  We.prototype = qe.prototype, qe.prototype.toString = function () {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (void 0 === this.width ? "" : Math.max(1, 0 | this.width)) + (this.comma ? "," : "") + (void 0 === this.precision ? "" : "." + Math.max(0, 0 | this.precision)) + (this.trim ? "~" : "") + this.type;
  };
  var Ge = {
    "%": function _(t, e) {
      return (100 * t).toFixed(e);
    },
    b: function b(t) {
      return Math.round(t).toString(2);
    },
    c: function c(t) {
      return t + "";
    },
    d: function d(t) {
      return Math.round(t).toString(10);
    },
    e: function e(t, _e2) {
      return t.toExponential(_e2);
    },
    f: function f(t, e) {
      return t.toFixed(e);
    },
    g: function g(t, e) {
      return t.toPrecision(e);
    },
    o: function o(t) {
      return Math.round(t).toString(8);
    },
    p: function p(t, e) {
      return Xe(100 * t, e);
    },
    r: Xe,
    s: function s(t, e) {
      var n = Fe(t, e);
      if (!n) return t + "";
      var r = n[0],
          i = n[1],
          o = i - (He = 3 * Math.max(-8, Math.min(8, Math.floor(i / 3)))) + 1,
          a = r.length;
      return o === a ? r : o > a ? r + new Array(o - a + 1).join("0") : o > 0 ? r.slice(0, o) + "." + r.slice(o) : "0." + new Array(1 - o).join("0") + Fe(t, Math.max(0, e + o - 1))[0];
    },
    X: function X(t) {
      return Math.round(t).toString(16).toUpperCase();
    },
    x: function x(t) {
      return Math.round(t).toString(16);
    }
  };

  function Ze(t) {
    return t;
  }

  var $e,
      Ke,
      Je,
      Qe = Array.prototype.map,
      tn = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];

  function en(t) {
    var e = t.domain;
    return t.ticks = function (t) {
      var n = e();
      return It(n[0], n[n.length - 1], null == t ? 10 : t);
    }, t.tickFormat = function (t, n) {
      var r = e();
      return function (t, e, n, r) {
        var i,
            o = zt(t, e, n);

        switch ((r = We(null == r ? ",f" : r)).type) {
          case "s":
            var a = Math.max(Math.abs(t), Math.abs(e));
            return null != r.precision || isNaN(i = function (t, e) {
              return Math.max(0, 3 * Math.max(-8, Math.min(8, Math.floor(Be(e) / 3))) - Be(Math.abs(t)));
            }(o, a)) || (r.precision = i), Je(r, a);

          case "":
          case "e":
          case "g":
          case "p":
          case "r":
            null != r.precision || isNaN(i = function (t, e) {
              return t = Math.abs(t), e = Math.abs(e) - t, Math.max(0, Be(e) - Be(t)) + 1;
            }(o, Math.max(Math.abs(t), Math.abs(e)))) || (r.precision = i - ("e" === r.type));
            break;

          case "f":
          case "%":
            null != r.precision || isNaN(i = function (t) {
              return Math.max(0, -Be(Math.abs(t)));
            }(o)) || (r.precision = i - 2 * ("%" === r.type));
        }

        return Ke(r);
      }(r[0], r[r.length - 1], null == t ? 10 : t, n);
    }, t.nice = function (n) {
      null == n && (n = 10);
      var r,
          i = e(),
          o = 0,
          a = i.length - 1,
          s = i[o],
          u = i[a];
      return u < s && (r = s, s = u, u = r, r = o, o = a, a = r), (r = Vt(s, u, n)) > 0 ? r = Vt(s = Math.floor(s / r) * r, u = Math.ceil(u / r) * r, n) : r < 0 && (r = Vt(s = Math.ceil(s * r) / r, u = Math.floor(u * r) / r, n)), r > 0 ? (i[o] = Math.floor(s / r) * r, i[a] = Math.ceil(u / r) * r, e(i)) : r < 0 && (i[o] = Math.ceil(s * r) / r, i[a] = Math.floor(u * r) / r, e(i)), t;
    }, t;
  }

  function nn(t, e) {
    var n,
        r = 0,
        i = (t = t.slice()).length - 1,
        o = t[r],
        a = t[i];
    return a < o && (n = r, r = i, i = n, n = o, o = a, a = n), t[r] = e.floor(o), t[i] = e.ceil(a), t;
  }

  function rn(t) {
    return Math.log(t);
  }

  function on(t) {
    return Math.exp(t);
  }

  function an(t) {
    return -Math.log(-t);
  }

  function sn(t) {
    return -Math.exp(-t);
  }

  function un(t) {
    return isFinite(t) ? +("1e" + t) : t < 0 ? 0 : t;
  }

  function cn(t) {
    return function (e) {
      return -t(-e);
    };
  }

  function ln(t) {
    var e,
        n,
        r = t(rn, on),
        i = r.domain,
        o = 10;

    function a() {
      return e = function (t) {
        return t === Math.E ? Math.log : 10 === t && Math.log10 || 2 === t && Math.log2 || (t = Math.log(t), function (e) {
          return Math.log(e) / t;
        });
      }(o), n = function (t) {
        return 10 === t ? un : t === Math.E ? Math.exp : function (e) {
          return Math.pow(t, e);
        };
      }(o), i()[0] < 0 ? (e = cn(e), n = cn(n), t(an, sn)) : t(rn, on), r;
    }

    return r.base = function (t) {
      return arguments.length ? (o = +t, a()) : o;
    }, r.domain = function (t) {
      return arguments.length ? (i(t), a()) : i();
    }, r.ticks = function (t) {
      var r,
          a = i(),
          s = a[0],
          u = a[a.length - 1];
      (r = u < s) && (f = s, s = u, u = f);
      var c,
          l,
          h,
          f = e(s),
          d = e(u),
          y = null == t ? 10 : +t,
          p = [];

      if (!(o % 1) && d - f < y) {
        if (f = Math.floor(f), d = Math.ceil(d), s > 0) {
          for (; f <= d; ++f) {
            for (l = 1, c = n(f); l < o; ++l) {
              if (!((h = c * l) < s)) {
                if (h > u) break;
                p.push(h);
              }
            }
          }
        } else for (; f <= d; ++f) {
          for (l = o - 1, c = n(f); l >= 1; --l) {
            if (!((h = c * l) < s)) {
              if (h > u) break;
              p.push(h);
            }
          }
        }

        2 * p.length < y && (p = It(s, u, y));
      } else p = It(f, d, Math.min(d - f, y)).map(n);

      return r ? p.reverse() : p;
    }, r.tickFormat = function (t, i) {
      if (null == i && (i = 10 === o ? ".0e" : ","), "function" != typeof i && (i = Ke(i)), t === 1 / 0) return i;
      null == t && (t = 10);
      var a = Math.max(1, o * t / r.ticks().length);
      return function (t) {
        var r = t / n(Math.round(e(t)));
        return r * o < o - .5 && (r *= o), r <= a ? i(t) : "";
      };
    }, r.nice = function () {
      return i(nn(i(), {
        floor: function floor(t) {
          return n(Math.floor(e(t)));
        },
        ceil: function ceil(t) {
          return n(Math.ceil(e(t)));
        }
      }));
    }, r;
  }

  $e = function (t) {
    var e,
        n,
        r = void 0 === t.grouping || void 0 === t.thousands ? Ze : (e = Qe.call(t.grouping, Number), n = t.thousands + "", function (t, r) {
      for (var i = t.length, o = [], a = 0, s = e[0], u = 0; i > 0 && s > 0 && (u + s + 1 > r && (s = Math.max(1, r - u)), o.push(t.substring(i -= s, i + s)), !((u += s + 1) > r));) {
        s = e[a = (a + 1) % e.length];
      }

      return o.reverse().join(n);
    }),
        i = void 0 === t.currency ? "" : t.currency[0] + "",
        o = void 0 === t.currency ? "" : t.currency[1] + "",
        a = void 0 === t.decimal ? "." : t.decimal + "",
        s = void 0 === t.numerals ? Ze : function (t) {
      return function (e) {
        return e.replace(/[0-9]/g, function (e) {
          return t[+e];
        });
      };
    }(Qe.call(t.numerals, String)),
        u = void 0 === t.percent ? "%" : t.percent + "",
        c = void 0 === t.minus ? "-" : t.minus + "",
        l = void 0 === t.nan ? "NaN" : t.nan + "";

    function h(t) {
      var e = (t = We(t)).fill,
          n = t.align,
          h = t.sign,
          f = t.symbol,
          d = t.zero,
          y = t.width,
          p = t.comma,
          g = t.precision,
          m = t.trim,
          _ = t.type;
      "n" === _ ? (p = !0, _ = "g") : Ge[_] || (void 0 === g && (g = 12), m = !0, _ = "g"), (d || "0" === e && "=" === n) && (d = !0, e = "0", n = "=");
      var x = "$" === f ? i : "#" === f && /[boxX]/.test(_) ? "0" + _.toLowerCase() : "",
          v = "$" === f ? o : /[%p]/.test(_) ? u : "",
          b = Ge[_],
          M = /[defgprs%]/.test(_);

      function w(t) {
        var i,
            o,
            u,
            f = x,
            w = v;
        if ("c" === _) w = b(t) + w, t = "";else {
          var C = (t = +t) < 0;
          if (t = isNaN(t) ? l : b(Math.abs(t), g), m && (t = function (t) {
            t: for (var e, n = t.length, r = 1, i = -1; r < n; ++r) {
              switch (t[r]) {
                case ".":
                  i = e = r;
                  break;

                case "0":
                  0 === i && (i = r), e = r;
                  break;

                default:
                  if (i > 0) {
                    if (!+t[r]) break t;
                    i = 0;
                  }

              }
            }

            return i > 0 ? t.slice(0, i) + t.slice(e + 1) : t;
          }(t)), C && 0 == +t && (C = !1), f = (C ? "(" === h ? h : c : "-" === h || "(" === h ? "" : h) + f, w = ("s" === _ ? tn[8 + He / 3] : "") + w + (C && "(" === h ? ")" : ""), M) for (i = -1, o = t.length; ++i < o;) {
            if (48 > (u = t.charCodeAt(i)) || u > 57) {
              w = (46 === u ? a + t.slice(i + 1) : t.slice(i)) + w, t = t.slice(0, i);
              break;
            }
          }
        }
        p && !d && (t = r(t, 1 / 0));
        var k = f.length + t.length + w.length,
            S = k < y ? new Array(y - k + 1).join(e) : "";

        switch (p && d && (t = r(S + t, S.length ? y - w.length : 1 / 0), S = ""), n) {
          case "<":
            t = f + t + w + S;
            break;

          case "=":
            t = f + S + t + w;
            break;

          case "^":
            t = S.slice(0, k = S.length >> 1) + f + t + w + S.slice(k);
            break;

          default:
            t = S + f + t + w;
        }

        return s(t);
      }

      return g = void 0 === g ? 6 : /[gprs]/.test(_) ? Math.max(1, Math.min(21, g)) : Math.max(0, Math.min(20, g)), w.toString = function () {
        return t + "";
      }, w;
    }

    return {
      format: h,
      formatPrefix: function formatPrefix(t, e) {
        var n = h(((t = We(t)).type = "f", t)),
            r = 3 * Math.max(-8, Math.min(8, Math.floor(Be(e) / 3))),
            i = Math.pow(10, -r),
            o = tn[8 + r / 3];
        return function (t) {
          return n(i * t) + o;
        };
      }
    };
  }({
    decimal: ".",
    thousands: ",",
    grouping: [3],
    currency: ["$", ""],
    minus: "-"
  }), Ke = $e.format, Je = $e.formatPrefix;
  var hn = new Date(),
      fn = new Date();

  function dn(t, e, n, r) {
    function i(e) {
      return t(e = 0 === arguments.length ? new Date() : new Date(+e)), e;
    }

    return i.floor = function (e) {
      return t(e = new Date(+e)), e;
    }, i.ceil = function (n) {
      return t(n = new Date(n - 1)), e(n, 1), t(n), n;
    }, i.round = function (t) {
      var e = i(t),
          n = i.ceil(t);
      return t - e < n - t ? e : n;
    }, i.offset = function (t, n) {
      return e(t = new Date(+t), null == n ? 1 : Math.floor(n)), t;
    }, i.range = function (n, r, o) {
      var a,
          s = [];
      if (n = i.ceil(n), o = null == o ? 1 : Math.floor(o), !(n < r && o > 0)) return s;

      do {
        s.push(a = new Date(+n)), e(n, o), t(n);
      } while (a < n && n < r);

      return s;
    }, i.filter = function (n) {
      return dn(function (e) {
        if (e >= e) for (; t(e), !n(e);) {
          e.setTime(e - 1);
        }
      }, function (t, r) {
        if (t >= t) if (r < 0) for (; ++r <= 0;) {
          for (; e(t, -1), !n(t);) {
            ;
          }
        } else for (; --r >= 0;) {
          for (; e(t, 1), !n(t);) {
            ;
          }
        }
      });
    }, n && (i.count = function (e, r) {
      return hn.setTime(+e), fn.setTime(+r), t(hn), t(fn), Math.floor(n(hn, fn));
    }, i.every = function (t) {
      return t = Math.floor(t), isFinite(t) && t > 0 ? t > 1 ? i.filter(r ? function (e) {
        return r(e) % t == 0;
      } : function (e) {
        return i.count(0, e) % t == 0;
      }) : i : null;
    }), i;
  }

  var yn = dn(function () {}, function (t, e) {
    t.setTime(+t + e);
  }, function (t, e) {
    return e - t;
  });

  yn.every = function (t) {
    return t = Math.floor(t), isFinite(t) && t > 0 ? t > 1 ? dn(function (e) {
      e.setTime(Math.floor(e / t) * t);
    }, function (e, n) {
      e.setTime(+e + n * t);
    }, function (e, n) {
      return (n - e) / t;
    }) : yn : null;
  };

  var pn = dn(function (t) {
    t.setTime(t - t.getMilliseconds());
  }, function (t, e) {
    t.setTime(+t + 1e3 * e);
  }, function (t, e) {
    return (e - t) / 1e3;
  }, function (t) {
    return t.getUTCSeconds();
  }),
      gn = dn(function (t) {
    t.setTime(t - t.getMilliseconds() - 1e3 * t.getSeconds());
  }, function (t, e) {
    t.setTime(+t + 6e4 * e);
  }, function (t, e) {
    return (e - t) / 6e4;
  }, function (t) {
    return t.getMinutes();
  }),
      mn = dn(function (t) {
    t.setTime(t - t.getMilliseconds() - 1e3 * t.getSeconds() - 6e4 * t.getMinutes());
  }, function (t, e) {
    t.setTime(+t + 36e5 * e);
  }, function (t, e) {
    return (e - t) / 36e5;
  }, function (t) {
    return t.getHours();
  }),
      _n = dn(function (t) {
    t.setHours(0, 0, 0, 0);
  }, function (t, e) {
    t.setDate(t.getDate() + e);
  }, function (t, e) {
    return (e - t - 6e4 * (e.getTimezoneOffset() - t.getTimezoneOffset())) / 864e5;
  }, function (t) {
    return t.getDate() - 1;
  });

  function xn(t) {
    return dn(function (e) {
      e.setDate(e.getDate() - (e.getDay() + 7 - t) % 7), e.setHours(0, 0, 0, 0);
    }, function (t, e) {
      t.setDate(t.getDate() + 7 * e);
    }, function (t, e) {
      return (e - t - 6e4 * (e.getTimezoneOffset() - t.getTimezoneOffset())) / 6048e5;
    });
  }

  var vn = xn(0),
      bn = xn(1),
      Mn = (xn(2), xn(3), xn(4)),
      wn = (xn(5), xn(6), dn(function (t) {
    t.setDate(1), t.setHours(0, 0, 0, 0);
  }, function (t, e) {
    t.setMonth(t.getMonth() + e);
  }, function (t, e) {
    return e.getMonth() - t.getMonth() + 12 * (e.getFullYear() - t.getFullYear());
  }, function (t) {
    return t.getMonth();
  })),
      Cn = dn(function (t) {
    t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
  }, function (t, e) {
    t.setFullYear(t.getFullYear() + e);
  }, function (t, e) {
    return e.getFullYear() - t.getFullYear();
  }, function (t) {
    return t.getFullYear();
  });

  Cn.every = function (t) {
    return isFinite(t = Math.floor(t)) && t > 0 ? dn(function (e) {
      e.setFullYear(Math.floor(e.getFullYear() / t) * t), e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
    }, function (e, n) {
      e.setFullYear(e.getFullYear() + n * t);
    }) : null;
  };

  var kn = dn(function (t) {
    t.setUTCSeconds(0, 0);
  }, function (t, e) {
    t.setTime(+t + 6e4 * e);
  }, function (t, e) {
    return (e - t) / 6e4;
  }, function (t) {
    return t.getUTCMinutes();
  }),
      Sn = dn(function (t) {
    t.setUTCMinutes(0, 0, 0);
  }, function (t, e) {
    t.setTime(+t + 36e5 * e);
  }, function (t, e) {
    return (e - t) / 36e5;
  }, function (t) {
    return t.getUTCHours();
  }),
      An = dn(function (t) {
    t.setUTCHours(0, 0, 0, 0);
  }, function (t, e) {
    t.setUTCDate(t.getUTCDate() + e);
  }, function (t, e) {
    return (e - t) / 864e5;
  }, function (t) {
    return t.getUTCDate() - 1;
  });

  function En(t) {
    return dn(function (e) {
      e.setUTCDate(e.getUTCDate() - (e.getUTCDay() + 7 - t) % 7), e.setUTCHours(0, 0, 0, 0);
    }, function (t, e) {
      t.setUTCDate(t.getUTCDate() + 7 * e);
    }, function (t, e) {
      return (e - t) / 6048e5;
    });
  }

  var Tn = En(0),
      Dn = En(1),
      Nn = (En(2), En(3), En(4)),
      Rn = (En(5), En(6), dn(function (t) {
    t.setUTCDate(1), t.setUTCHours(0, 0, 0, 0);
  }, function (t, e) {
    t.setUTCMonth(t.getUTCMonth() + e);
  }, function (t, e) {
    return e.getUTCMonth() - t.getUTCMonth() + 12 * (e.getUTCFullYear() - t.getUTCFullYear());
  }, function (t) {
    return t.getUTCMonth();
  })),
      Ln = dn(function (t) {
    t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  }, function (t, e) {
    t.setUTCFullYear(t.getUTCFullYear() + e);
  }, function (t, e) {
    return e.getUTCFullYear() - t.getUTCFullYear();
  }, function (t) {
    return t.getUTCFullYear();
  });

  function Pn(t) {
    if (0 <= t.y && t.y < 100) {
      var e = new Date(-1, t.m, t.d, t.H, t.M, t.S, t.L);
      return e.setFullYear(t.y), e;
    }

    return new Date(t.y, t.m, t.d, t.H, t.M, t.S, t.L);
  }

  function On(t) {
    if (0 <= t.y && t.y < 100) {
      var e = new Date(Date.UTC(-1, t.m, t.d, t.H, t.M, t.S, t.L));
      return e.setUTCFullYear(t.y), e;
    }

    return new Date(Date.UTC(t.y, t.m, t.d, t.H, t.M, t.S, t.L));
  }

  function Un(t, e, n) {
    return {
      y: t,
      m: e,
      d: n,
      H: 0,
      M: 0,
      S: 0,
      L: 0
    };
  }

  Ln.every = function (t) {
    return isFinite(t = Math.floor(t)) && t > 0 ? dn(function (e) {
      e.setUTCFullYear(Math.floor(e.getUTCFullYear() / t) * t), e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
    }, function (e, n) {
      e.setUTCFullYear(e.getUTCFullYear() + n * t);
    }) : null;
  };

  var In,
      Vn,
      zn,
      jn = {
    "-": "",
    _: " ",
    0: "0"
  },
      Fn = /^\s*\d+/,
      Bn = /^%/,
      Hn = /[\\^$*+?|[\]().{}]/g;

  function Yn(t, e, n) {
    var r = t < 0 ? "-" : "",
        i = (r ? -t : t) + "",
        o = i.length;
    return r + (o < n ? new Array(n - o + 1).join(e) + i : i);
  }

  function Wn(t) {
    return t.replace(Hn, "\\$&");
  }

  function qn(t) {
    return new RegExp("^(?:" + t.map(Wn).join("|") + ")", "i");
  }

  function Xn(t) {
    for (var e = {}, n = -1, r = t.length; ++n < r;) {
      e[t[n].toLowerCase()] = n;
    }

    return e;
  }

  function Gn(t, e, n) {
    var r = Fn.exec(e.slice(n, n + 1));
    return r ? (t.w = +r[0], n + r[0].length) : -1;
  }

  function Zn(t, e, n) {
    var r = Fn.exec(e.slice(n, n + 1));
    return r ? (t.u = +r[0], n + r[0].length) : -1;
  }

  function $n(t, e, n) {
    var r = Fn.exec(e.slice(n, n + 2));
    return r ? (t.U = +r[0], n + r[0].length) : -1;
  }

  function Kn(t, e, n) {
    var r = Fn.exec(e.slice(n, n + 2));
    return r ? (t.V = +r[0], n + r[0].length) : -1;
  }

  function Jn(t, e, n) {
    var r = Fn.exec(e.slice(n, n + 2));
    return r ? (t.W = +r[0], n + r[0].length) : -1;
  }

  function Qn(t, e, n) {
    var r = Fn.exec(e.slice(n, n + 4));
    return r ? (t.y = +r[0], n + r[0].length) : -1;
  }

  function tr(t, e, n) {
    var r = Fn.exec(e.slice(n, n + 2));
    return r ? (t.y = +r[0] + (+r[0] > 68 ? 1900 : 2e3), n + r[0].length) : -1;
  }

  function er(t, e, n) {
    var r = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(e.slice(n, n + 6));
    return r ? (t.Z = r[1] ? 0 : -(r[2] + (r[3] || "00")), n + r[0].length) : -1;
  }

  function nr(t, e, n) {
    var r = Fn.exec(e.slice(n, n + 1));
    return r ? (t.q = 3 * r[0] - 3, n + r[0].length) : -1;
  }

  function rr(t, e, n) {
    var r = Fn.exec(e.slice(n, n + 2));
    return r ? (t.m = r[0] - 1, n + r[0].length) : -1;
  }

  function ir(t, e, n) {
    var r = Fn.exec(e.slice(n, n + 2));
    return r ? (t.d = +r[0], n + r[0].length) : -1;
  }

  function or(t, e, n) {
    var r = Fn.exec(e.slice(n, n + 3));
    return r ? (t.m = 0, t.d = +r[0], n + r[0].length) : -1;
  }

  function ar(t, e, n) {
    var r = Fn.exec(e.slice(n, n + 2));
    return r ? (t.H = +r[0], n + r[0].length) : -1;
  }

  function sr(t, e, n) {
    var r = Fn.exec(e.slice(n, n + 2));
    return r ? (t.M = +r[0], n + r[0].length) : -1;
  }

  function ur(t, e, n) {
    var r = Fn.exec(e.slice(n, n + 2));
    return r ? (t.S = +r[0], n + r[0].length) : -1;
  }

  function cr(t, e, n) {
    var r = Fn.exec(e.slice(n, n + 3));
    return r ? (t.L = +r[0], n + r[0].length) : -1;
  }

  function lr(t, e, n) {
    var r = Fn.exec(e.slice(n, n + 6));
    return r ? (t.L = Math.floor(r[0] / 1e3), n + r[0].length) : -1;
  }

  function hr(t, e, n) {
    var r = Bn.exec(e.slice(n, n + 1));
    return r ? n + r[0].length : -1;
  }

  function fr(t, e, n) {
    var r = Fn.exec(e.slice(n));
    return r ? (t.Q = +r[0], n + r[0].length) : -1;
  }

  function dr(t, e, n) {
    var r = Fn.exec(e.slice(n));
    return r ? (t.s = +r[0], n + r[0].length) : -1;
  }

  function yr(t, e) {
    return Yn(t.getDate(), e, 2);
  }

  function pr(t, e) {
    return Yn(t.getHours(), e, 2);
  }

  function gr(t, e) {
    return Yn(t.getHours() % 12 || 12, e, 2);
  }

  function mr(t, e) {
    return Yn(1 + _n.count(Cn(t), t), e, 3);
  }

  function _r(t, e) {
    return Yn(t.getMilliseconds(), e, 3);
  }

  function xr(t, e) {
    return _r(t, e) + "000";
  }

  function vr(t, e) {
    return Yn(t.getMonth() + 1, e, 2);
  }

  function br(t, e) {
    return Yn(t.getMinutes(), e, 2);
  }

  function Mr(t, e) {
    return Yn(t.getSeconds(), e, 2);
  }

  function wr(t) {
    var e = t.getDay();
    return 0 === e ? 7 : e;
  }

  function Cr(t, e) {
    return Yn(vn.count(Cn(t) - 1, t), e, 2);
  }

  function kr(t, e) {
    var n = t.getDay();
    return t = n >= 4 || 0 === n ? Mn(t) : Mn.ceil(t), Yn(Mn.count(Cn(t), t) + (4 === Cn(t).getDay()), e, 2);
  }

  function Sr(t) {
    return t.getDay();
  }

  function Ar(t, e) {
    return Yn(bn.count(Cn(t) - 1, t), e, 2);
  }

  function Er(t, e) {
    return Yn(t.getFullYear() % 100, e, 2);
  }

  function Tr(t, e) {
    return Yn(t.getFullYear() % 1e4, e, 4);
  }

  function Dr(t) {
    var e = t.getTimezoneOffset();
    return (e > 0 ? "-" : (e *= -1, "+")) + Yn(e / 60 | 0, "0", 2) + Yn(e % 60, "0", 2);
  }

  function Nr(t, e) {
    return Yn(t.getUTCDate(), e, 2);
  }

  function Rr(t, e) {
    return Yn(t.getUTCHours(), e, 2);
  }

  function Lr(t, e) {
    return Yn(t.getUTCHours() % 12 || 12, e, 2);
  }

  function Pr(t, e) {
    return Yn(1 + An.count(Ln(t), t), e, 3);
  }

  function Or(t, e) {
    return Yn(t.getUTCMilliseconds(), e, 3);
  }

  function Ur(t, e) {
    return Or(t, e) + "000";
  }

  function Ir(t, e) {
    return Yn(t.getUTCMonth() + 1, e, 2);
  }

  function Vr(t, e) {
    return Yn(t.getUTCMinutes(), e, 2);
  }

  function zr(t, e) {
    return Yn(t.getUTCSeconds(), e, 2);
  }

  function jr(t) {
    var e = t.getUTCDay();
    return 0 === e ? 7 : e;
  }

  function Fr(t, e) {
    return Yn(Tn.count(Ln(t) - 1, t), e, 2);
  }

  function Br(t, e) {
    var n = t.getUTCDay();
    return t = n >= 4 || 0 === n ? Nn(t) : Nn.ceil(t), Yn(Nn.count(Ln(t), t) + (4 === Ln(t).getUTCDay()), e, 2);
  }

  function Hr(t) {
    return t.getUTCDay();
  }

  function Yr(t, e) {
    return Yn(Dn.count(Ln(t) - 1, t), e, 2);
  }

  function Wr(t, e) {
    return Yn(t.getUTCFullYear() % 100, e, 2);
  }

  function qr(t, e) {
    return Yn(t.getUTCFullYear() % 1e4, e, 4);
  }

  function Xr() {
    return "+0000";
  }

  function Gr() {
    return "%";
  }

  function Zr(t) {
    return +t;
  }

  function $r(t) {
    return Math.floor(+t / 1e3);
  }

  function Kr(t) {
    return new Date(t);
  }

  function Jr(t) {
    return t instanceof Date ? +t : +new Date(+t);
  }

  function Qr(t, e, n, r, i, o, a, s, u) {
    var c = je(),
        l = c.invert,
        h = c.domain,
        f = u(".%L"),
        d = u(":%S"),
        y = u("%I:%M"),
        p = u("%I %p"),
        g = u("%a %d"),
        m = u("%b %d"),
        _ = u("%B"),
        x = u("%Y"),
        v = [[a, 1, 1e3], [a, 5, 5e3], [a, 15, 15e3], [a, 30, 3e4], [o, 1, 6e4], [o, 5, 3e5], [o, 15, 9e5], [o, 30, 18e5], [i, 1, 36e5], [i, 3, 108e5], [i, 6, 216e5], [i, 12, 432e5], [r, 1, 864e5], [r, 2, 1728e5], [n, 1, 6048e5], [e, 1, 2592e6], [e, 3, 7776e6], [t, 1, 31536e6]];

    function b(s) {
      return (a(s) < s ? f : o(s) < s ? d : i(s) < s ? y : r(s) < s ? p : e(s) < s ? n(s) < s ? g : m : t(s) < s ? _ : x)(s);
    }

    function M(e, n, r) {
      if (null == e && (e = 10), "number" == typeof e) {
        var i,
            o = Math.abs(r - n) / e,
            a = Nt(function (t) {
          return t[2];
        }).right(v, o);
        return a === v.length ? (i = zt(n / 31536e6, r / 31536e6, e), e = t) : a ? (i = (a = v[o / v[a - 1][2] < v[a][2] / o ? a - 1 : a])[1], e = a[0]) : (i = Math.max(zt(n, r, e), 1), e = s), e.every(i);
      }

      return e;
    }

    return c.invert = function (t) {
      return new Date(l(t));
    }, c.domain = function (t) {
      return arguments.length ? h(Array.from(t, Jr)) : h().map(Kr);
    }, c.ticks = function (t) {
      var e,
          n = h(),
          r = n[0],
          i = n[n.length - 1],
          o = i < r;
      return o && (e = r, r = i, i = e), e = (e = M(t, r, i)) ? e.range(r, i + 1) : [], o ? e.reverse() : e;
    }, c.tickFormat = function (t, e) {
      return null == e ? b : u(e);
    }, c.nice = function (t) {
      var e = h();
      return (t = M(t, e[0], e[e.length - 1])) ? h(nn(e, t)) : c;
    }, c.copy = function () {
      return Ve(c, Qr(t, e, n, r, i, o, a, s, u));
    }, c;
  }

  In = function (t) {
    var e = t.dateTime,
        n = t.date,
        r = t.time,
        i = t.periods,
        o = t.days,
        _a = t.shortDays,
        s = t.months,
        u = t.shortMonths,
        c = qn(i),
        l = Xn(i),
        h = qn(o),
        f = Xn(o),
        d = qn(_a),
        y = Xn(_a),
        p = qn(s),
        g = Xn(s),
        m = qn(u),
        _ = Xn(u),
        x = {
      a: function a(t) {
        return _a[t.getDay()];
      },
      A: function A(t) {
        return o[t.getDay()];
      },
      b: function b(t) {
        return u[t.getMonth()];
      },
      B: function B(t) {
        return s[t.getMonth()];
      },
      c: null,
      d: yr,
      e: yr,
      f: xr,
      H: pr,
      I: gr,
      j: mr,
      L: _r,
      m: vr,
      M: br,
      p: function p(t) {
        return i[+(t.getHours() >= 12)];
      },
      q: function q(t) {
        return 1 + ~~(t.getMonth() / 3);
      },
      Q: Zr,
      s: $r,
      S: Mr,
      u: wr,
      U: Cr,
      V: kr,
      w: Sr,
      W: Ar,
      x: null,
      X: null,
      y: Er,
      Y: Tr,
      Z: Dr,
      "%": Gr
    },
        v = {
      a: function a(t) {
        return _a[t.getUTCDay()];
      },
      A: function A(t) {
        return o[t.getUTCDay()];
      },
      b: function b(t) {
        return u[t.getUTCMonth()];
      },
      B: function B(t) {
        return s[t.getUTCMonth()];
      },
      c: null,
      d: Nr,
      e: Nr,
      f: Ur,
      H: Rr,
      I: Lr,
      j: Pr,
      L: Or,
      m: Ir,
      M: Vr,
      p: function p(t) {
        return i[+(t.getUTCHours() >= 12)];
      },
      q: function q(t) {
        return 1 + ~~(t.getUTCMonth() / 3);
      },
      Q: Zr,
      s: $r,
      S: zr,
      u: jr,
      U: Fr,
      V: Br,
      w: Hr,
      W: Yr,
      x: null,
      X: null,
      y: Wr,
      Y: qr,
      Z: Xr,
      "%": Gr
    },
        b = {
      a: function a(t, e, n) {
        var r = d.exec(e.slice(n));
        return r ? (t.w = y[r[0].toLowerCase()], n + r[0].length) : -1;
      },
      A: function A(t, e, n) {
        var r = h.exec(e.slice(n));
        return r ? (t.w = f[r[0].toLowerCase()], n + r[0].length) : -1;
      },
      b: function b(t, e, n) {
        var r = m.exec(e.slice(n));
        return r ? (t.m = _[r[0].toLowerCase()], n + r[0].length) : -1;
      },
      B: function B(t, e, n) {
        var r = p.exec(e.slice(n));
        return r ? (t.m = g[r[0].toLowerCase()], n + r[0].length) : -1;
      },
      c: function c(t, n, r) {
        return C(t, e, n, r);
      },
      d: ir,
      e: ir,
      f: lr,
      H: ar,
      I: ar,
      j: or,
      L: cr,
      m: rr,
      M: sr,
      p: function p(t, e, n) {
        var r = c.exec(e.slice(n));
        return r ? (t.p = l[r[0].toLowerCase()], n + r[0].length) : -1;
      },
      q: nr,
      Q: fr,
      s: dr,
      S: ur,
      u: Zn,
      U: $n,
      V: Kn,
      w: Gn,
      W: Jn,
      x: function x(t, e, r) {
        return C(t, n, e, r);
      },
      X: function X(t, e, n) {
        return C(t, r, e, n);
      },
      y: tr,
      Y: Qn,
      Z: er,
      "%": hr
    };

    function M(t, e) {
      return function (n) {
        var r,
            i,
            o,
            a = [],
            s = -1,
            u = 0,
            c = t.length;

        for (n instanceof Date || (n = new Date(+n)); ++s < c;) {
          37 === t.charCodeAt(s) && (a.push(t.slice(u, s)), null != (i = jn[r = t.charAt(++s)]) ? r = t.charAt(++s) : i = "e" === r ? " " : "0", (o = e[r]) && (r = o(n, i)), a.push(r), u = s + 1);
        }

        return a.push(t.slice(u, s)), a.join("");
      };
    }

    function w(t, e) {
      return function (n) {
        var r,
            i,
            o = Un(1900, void 0, 1);
        if (C(o, t, n += "", 0) != n.length) return null;
        if ("Q" in o) return new Date(o.Q);
        if ("s" in o) return new Date(1e3 * o.s + ("L" in o ? o.L : 0));

        if (e && !("Z" in o) && (o.Z = 0), "p" in o && (o.H = o.H % 12 + 12 * o.p), void 0 === o.m && (o.m = "q" in o ? o.q : 0), "V" in o) {
          if (o.V < 1 || o.V > 53) return null;
          "w" in o || (o.w = 1), "Z" in o ? (i = (r = On(Un(o.y, 0, 1))).getUTCDay(), r = i > 4 || 0 === i ? Dn.ceil(r) : Dn(r), r = An.offset(r, 7 * (o.V - 1)), o.y = r.getUTCFullYear(), o.m = r.getUTCMonth(), o.d = r.getUTCDate() + (o.w + 6) % 7) : (i = (r = Pn(Un(o.y, 0, 1))).getDay(), r = i > 4 || 0 === i ? bn.ceil(r) : bn(r), r = _n.offset(r, 7 * (o.V - 1)), o.y = r.getFullYear(), o.m = r.getMonth(), o.d = r.getDate() + (o.w + 6) % 7);
        } else ("W" in o || "U" in o) && ("w" in o || (o.w = "u" in o ? o.u % 7 : "W" in o ? 1 : 0), i = "Z" in o ? On(Un(o.y, 0, 1)).getUTCDay() : Pn(Un(o.y, 0, 1)).getDay(), o.m = 0, o.d = "W" in o ? (o.w + 6) % 7 + 7 * o.W - (i + 5) % 7 : o.w + 7 * o.U - (i + 6) % 7);

        return "Z" in o ? (o.H += o.Z / 100 | 0, o.M += o.Z % 100, On(o)) : Pn(o);
      };
    }

    function C(t, e, n, r) {
      for (var i, o, a = 0, s = e.length, u = n.length; a < s;) {
        if (r >= u) return -1;

        if (37 === (i = e.charCodeAt(a++))) {
          if (i = e.charAt(a++), !(o = b[i in jn ? e.charAt(a++) : i]) || (r = o(t, n, r)) < 0) return -1;
        } else if (i != n.charCodeAt(r++)) return -1;
      }

      return r;
    }

    return x.x = M(n, x), x.X = M(r, x), x.c = M(e, x), v.x = M(n, v), v.X = M(r, v), v.c = M(e, v), {
      format: function format(t) {
        var e = M(t += "", x);
        return e.toString = function () {
          return t;
        }, e;
      },
      parse: function parse(t) {
        var e = w(t += "", !1);
        return e.toString = function () {
          return t;
        }, e;
      },
      utcFormat: function utcFormat(t) {
        var e = M(t += "", v);
        return e.toString = function () {
          return t;
        }, e;
      },
      utcParse: function utcParse(t) {
        var e = w(t += "", !0);
        return e.toString = function () {
          return t;
        }, e;
      }
    };
  }({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: ["AM", "PM"],
    days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
  }), Vn = In.format, In.parse, zn = In.utcFormat, In.utcParse;
  var ti = Math.PI,
      ei = 2 * ti,
      ni = ei - 1e-6;

  function ri() {
    this._x0 = this._y0 = this._x1 = this._y1 = null, this._ = "";
  }

  function ii() {
    return new ri();
  }

  function oi(t) {
    return function () {
      return t;
    };
  }

  function ai(t) {
    this._context = t;
  }

  function si(t) {
    return new ai(t);
  }

  function ui(t) {
    return t[0];
  }

  function ci(t) {
    return t[1];
  }

  function li() {
    var t = ui,
        e = ci,
        n = oi(!0),
        r = null,
        i = si,
        o = null;

    function a(a) {
      var s,
          u,
          c,
          l = a.length,
          h = !1;

      for (null == r && (o = i(c = ii())), s = 0; s <= l; ++s) {
        !(s < l && n(u = a[s], s, a)) === h && ((h = !h) ? o.lineStart() : o.lineEnd()), h && o.point(+t(u, s, a), +e(u, s, a));
      }

      if (c) return o = null, c + "" || null;
    }

    return a.x = function (e) {
      return arguments.length ? (t = "function" == typeof e ? e : oi(+e), a) : t;
    }, a.y = function (t) {
      return arguments.length ? (e = "function" == typeof t ? t : oi(+t), a) : e;
    }, a.defined = function (t) {
      return arguments.length ? (n = "function" == typeof t ? t : oi(!!t), a) : n;
    }, a.curve = function (t) {
      return arguments.length ? (i = t, null != r && (o = i(r)), a) : i;
    }, a.context = function (t) {
      return arguments.length ? (null == t ? r = o = null : o = i(r = t), a) : r;
    }, a;
  }

  function hi() {}

  function fi(t, e, n) {
    t._context.bezierCurveTo((2 * t._x0 + t._x1) / 3, (2 * t._y0 + t._y1) / 3, (t._x0 + 2 * t._x1) / 3, (t._y0 + 2 * t._y1) / 3, (t._x0 + 4 * t._x1 + e) / 6, (t._y0 + 4 * t._y1 + n) / 6);
  }

  function di(t) {
    this._context = t;
  }

  function yi(t) {
    this._context = t;
  }

  function pi(t) {
    this._context = t;
  }

  function gi(t, e) {
    this._basis = new di(t), this._beta = e;
  }

  ri.prototype = ii.prototype = {
    constructor: ri,
    moveTo: function moveTo(t, e) {
      this._ += "M" + (this._x0 = this._x1 = +t) + "," + (this._y0 = this._y1 = +e);
    },
    closePath: function closePath() {
      null !== this._x1 && (this._x1 = this._x0, this._y1 = this._y0, this._ += "Z");
    },
    lineTo: function lineTo(t, e) {
      this._ += "L" + (this._x1 = +t) + "," + (this._y1 = +e);
    },
    quadraticCurveTo: function quadraticCurveTo(t, e, n, r) {
      this._ += "Q" + +t + "," + +e + "," + (this._x1 = +n) + "," + (this._y1 = +r);
    },
    bezierCurveTo: function bezierCurveTo(t, e, n, r, i, o) {
      this._ += "C" + +t + "," + +e + "," + +n + "," + +r + "," + (this._x1 = +i) + "," + (this._y1 = +o);
    },
    arcTo: function arcTo(t, e, n, r, i) {
      t = +t, e = +e, n = +n, r = +r, i = +i;
      var o = this._x1,
          a = this._y1,
          s = n - t,
          u = r - e,
          c = o - t,
          l = a - e,
          h = c * c + l * l;
      if (i < 0) throw new Error("negative radius: " + i);
      if (null === this._x1) this._ += "M" + (this._x1 = t) + "," + (this._y1 = e);else if (h > 1e-6) if (Math.abs(l * s - u * c) > 1e-6 && i) {
        var f = n - o,
            d = r - a,
            y = s * s + u * u,
            p = f * f + d * d,
            g = Math.sqrt(y),
            m = Math.sqrt(h),
            _ = i * Math.tan((ti - Math.acos((y + h - p) / (2 * g * m))) / 2),
            x = _ / m,
            v = _ / g;

        Math.abs(x - 1) > 1e-6 && (this._ += "L" + (t + x * c) + "," + (e + x * l)), this._ += "A" + i + "," + i + ",0,0," + +(l * f > c * d) + "," + (this._x1 = t + v * s) + "," + (this._y1 = e + v * u);
      } else this._ += "L" + (this._x1 = t) + "," + (this._y1 = e);
    },
    arc: function arc(t, e, n, r, i, o) {
      t = +t, e = +e, o = !!o;
      var a = (n = +n) * Math.cos(r),
          s = n * Math.sin(r),
          u = t + a,
          c = e + s,
          l = 1 ^ o,
          h = o ? r - i : i - r;
      if (n < 0) throw new Error("negative radius: " + n);
      null === this._x1 ? this._ += "M" + u + "," + c : (Math.abs(this._x1 - u) > 1e-6 || Math.abs(this._y1 - c) > 1e-6) && (this._ += "L" + u + "," + c), n && (h < 0 && (h = h % ei + ei), h > ni ? this._ += "A" + n + "," + n + ",0,1," + l + "," + (t - a) + "," + (e - s) + "A" + n + "," + n + ",0,1," + l + "," + (this._x1 = u) + "," + (this._y1 = c) : h > 1e-6 && (this._ += "A" + n + "," + n + ",0," + +(h >= ti) + "," + l + "," + (this._x1 = t + n * Math.cos(i)) + "," + (this._y1 = e + n * Math.sin(i))));
    },
    rect: function rect(t, e, n, r) {
      this._ += "M" + (this._x0 = this._x1 = +t) + "," + (this._y0 = this._y1 = +e) + "h" + +n + "v" + +r + "h" + -n + "Z";
    },
    toString: function toString() {
      return this._;
    }
  }, ai.prototype = {
    areaStart: function areaStart() {
      this._line = 0;
    },
    areaEnd: function areaEnd() {
      this._line = NaN;
    },
    lineStart: function lineStart() {
      this._point = 0;
    },
    lineEnd: function lineEnd() {
      (this._line || 0 !== this._line && 1 === this._point) && this._context.closePath(), this._line = 1 - this._line;
    },
    point: function point(t, e) {
      switch (t = +t, e = +e, this._point) {
        case 0:
          this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
          break;

        case 1:
          this._point = 2;

        default:
          this._context.lineTo(t, e);

      }
    }
  }, di.prototype = {
    areaStart: function areaStart() {
      this._line = 0;
    },
    areaEnd: function areaEnd() {
      this._line = NaN;
    },
    lineStart: function lineStart() {
      this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
    },
    lineEnd: function lineEnd() {
      switch (this._point) {
        case 3:
          fi(this, this._x1, this._y1);

        case 2:
          this._context.lineTo(this._x1, this._y1);

      }

      (this._line || 0 !== this._line && 1 === this._point) && this._context.closePath(), this._line = 1 - this._line;
    },
    point: function point(t, e) {
      switch (t = +t, e = +e, this._point) {
        case 0:
          this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
          break;

        case 1:
          this._point = 2;
          break;

        case 2:
          this._point = 3, this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);

        default:
          fi(this, t, e);
      }

      this._x0 = this._x1, this._x1 = t, this._y0 = this._y1, this._y1 = e;
    }
  }, yi.prototype = {
    areaStart: hi,
    areaEnd: hi,
    lineStart: function lineStart() {
      this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN, this._point = 0;
    },
    lineEnd: function lineEnd() {
      switch (this._point) {
        case 1:
          this._context.moveTo(this._x2, this._y2), this._context.closePath();
          break;

        case 2:
          this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3), this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3), this._context.closePath();
          break;

        case 3:
          this.point(this._x2, this._y2), this.point(this._x3, this._y3), this.point(this._x4, this._y4);
      }
    },
    point: function point(t, e) {
      switch (t = +t, e = +e, this._point) {
        case 0:
          this._point = 1, this._x2 = t, this._y2 = e;
          break;

        case 1:
          this._point = 2, this._x3 = t, this._y3 = e;
          break;

        case 2:
          this._point = 3, this._x4 = t, this._y4 = e, this._context.moveTo((this._x0 + 4 * this._x1 + t) / 6, (this._y0 + 4 * this._y1 + e) / 6);
          break;

        default:
          fi(this, t, e);
      }

      this._x0 = this._x1, this._x1 = t, this._y0 = this._y1, this._y1 = e;
    }
  }, pi.prototype = {
    areaStart: function areaStart() {
      this._line = 0;
    },
    areaEnd: function areaEnd() {
      this._line = NaN;
    },
    lineStart: function lineStart() {
      this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
    },
    lineEnd: function lineEnd() {
      (this._line || 0 !== this._line && 3 === this._point) && this._context.closePath(), this._line = 1 - this._line;
    },
    point: function point(t, e) {
      switch (t = +t, e = +e, this._point) {
        case 0:
          this._point = 1;
          break;

        case 1:
          this._point = 2;
          break;

        case 2:
          this._point = 3;
          var n = (this._x0 + 4 * this._x1 + t) / 6,
              r = (this._y0 + 4 * this._y1 + e) / 6;
          this._line ? this._context.lineTo(n, r) : this._context.moveTo(n, r);
          break;

        case 3:
          this._point = 4;

        default:
          fi(this, t, e);
      }

      this._x0 = this._x1, this._x1 = t, this._y0 = this._y1, this._y1 = e;
    }
  }, gi.prototype = {
    lineStart: function lineStart() {
      this._x = [], this._y = [], this._basis.lineStart();
    },
    lineEnd: function lineEnd() {
      var t = this._x,
          e = this._y,
          n = t.length - 1;
      if (n > 0) for (var r, i = t[0], o = e[0], a = t[n] - i, s = e[n] - o, u = -1; ++u <= n;) {
        r = u / n, this._basis.point(this._beta * t[u] + (1 - this._beta) * (i + r * a), this._beta * e[u] + (1 - this._beta) * (o + r * s));
      }
      this._x = this._y = null, this._basis.lineEnd();
    },
    point: function point(t, e) {
      this._x.push(+t), this._y.push(+e);
    }
  };

  var mi = function t(e) {
    function n(t) {
      return 1 === e ? new di(t) : new gi(t, e);
    }

    return n.beta = function (e) {
      return t(+e);
    }, n;
  }(.85);

  function _i(t, e, n) {
    t._context.bezierCurveTo(t._x1 + t._k * (t._x2 - t._x0), t._y1 + t._k * (t._y2 - t._y0), t._x2 + t._k * (t._x1 - e), t._y2 + t._k * (t._y1 - n), t._x2, t._y2);
  }

  function xi(t, e) {
    this._context = t, this._k = (1 - e) / 6;
  }

  xi.prototype = {
    areaStart: function areaStart() {
      this._line = 0;
    },
    areaEnd: function areaEnd() {
      this._line = NaN;
    },
    lineStart: function lineStart() {
      this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._point = 0;
    },
    lineEnd: function lineEnd() {
      switch (this._point) {
        case 2:
          this._context.lineTo(this._x2, this._y2);

          break;

        case 3:
          _i(this, this._x1, this._y1);

      }

      (this._line || 0 !== this._line && 1 === this._point) && this._context.closePath(), this._line = 1 - this._line;
    },
    point: function point(t, e) {
      switch (t = +t, e = +e, this._point) {
        case 0:
          this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
          break;

        case 1:
          this._point = 2, this._x1 = t, this._y1 = e;
          break;

        case 2:
          this._point = 3;

        default:
          _i(this, t, e);

      }

      this._x0 = this._x1, this._x1 = this._x2, this._x2 = t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
    }
  };

  var vi = function t(e) {
    function n(t) {
      return new xi(t, e);
    }

    return n.tension = function (e) {
      return t(+e);
    }, n;
  }(0);

  function bi(t, e) {
    this._context = t, this._k = (1 - e) / 6;
  }

  bi.prototype = {
    areaStart: hi,
    areaEnd: hi,
    lineStart: function lineStart() {
      this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN, this._point = 0;
    },
    lineEnd: function lineEnd() {
      switch (this._point) {
        case 1:
          this._context.moveTo(this._x3, this._y3), this._context.closePath();
          break;

        case 2:
          this._context.lineTo(this._x3, this._y3), this._context.closePath();
          break;

        case 3:
          this.point(this._x3, this._y3), this.point(this._x4, this._y4), this.point(this._x5, this._y5);
      }
    },
    point: function point(t, e) {
      switch (t = +t, e = +e, this._point) {
        case 0:
          this._point = 1, this._x3 = t, this._y3 = e;
          break;

        case 1:
          this._point = 2, this._context.moveTo(this._x4 = t, this._y4 = e);
          break;

        case 2:
          this._point = 3, this._x5 = t, this._y5 = e;
          break;

        default:
          _i(this, t, e);

      }

      this._x0 = this._x1, this._x1 = this._x2, this._x2 = t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
    }
  };

  var Mi = function t(e) {
    function n(t) {
      return new bi(t, e);
    }

    return n.tension = function (e) {
      return t(+e);
    }, n;
  }(0);

  function wi(t, e) {
    this._context = t, this._k = (1 - e) / 6;
  }

  wi.prototype = {
    areaStart: function areaStart() {
      this._line = 0;
    },
    areaEnd: function areaEnd() {
      this._line = NaN;
    },
    lineStart: function lineStart() {
      this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._point = 0;
    },
    lineEnd: function lineEnd() {
      (this._line || 0 !== this._line && 3 === this._point) && this._context.closePath(), this._line = 1 - this._line;
    },
    point: function point(t, e) {
      switch (t = +t, e = +e, this._point) {
        case 0:
          this._point = 1;
          break;

        case 1:
          this._point = 2;
          break;

        case 2:
          this._point = 3, this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
          break;

        case 3:
          this._point = 4;

        default:
          _i(this, t, e);

      }

      this._x0 = this._x1, this._x1 = this._x2, this._x2 = t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
    }
  };

  var Ci = function t(e) {
    function n(t) {
      return new wi(t, e);
    }

    return n.tension = function (e) {
      return t(+e);
    }, n;
  }(0);

  function ki(t, e, n) {
    var r = t._x1,
        i = t._y1,
        o = t._x2,
        a = t._y2;

    if (t._l01_a > 1e-12) {
      var s = 2 * t._l01_2a + 3 * t._l01_a * t._l12_a + t._l12_2a,
          u = 3 * t._l01_a * (t._l01_a + t._l12_a);
      r = (r * s - t._x0 * t._l12_2a + t._x2 * t._l01_2a) / u, i = (i * s - t._y0 * t._l12_2a + t._y2 * t._l01_2a) / u;
    }

    if (t._l23_a > 1e-12) {
      var c = 2 * t._l23_2a + 3 * t._l23_a * t._l12_a + t._l12_2a,
          l = 3 * t._l23_a * (t._l23_a + t._l12_a);
      o = (o * c + t._x1 * t._l23_2a - e * t._l12_2a) / l, a = (a * c + t._y1 * t._l23_2a - n * t._l12_2a) / l;
    }

    t._context.bezierCurveTo(r, i, o, a, t._x2, t._y2);
  }

  function Si(t, e) {
    this._context = t, this._alpha = e;
  }

  Si.prototype = {
    areaStart: function areaStart() {
      this._line = 0;
    },
    areaEnd: function areaEnd() {
      this._line = NaN;
    },
    lineStart: function lineStart() {
      this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function lineEnd() {
      switch (this._point) {
        case 2:
          this._context.lineTo(this._x2, this._y2);

          break;

        case 3:
          this.point(this._x2, this._y2);
      }

      (this._line || 0 !== this._line && 1 === this._point) && this._context.closePath(), this._line = 1 - this._line;
    },
    point: function point(t, e) {
      if (t = +t, e = +e, this._point) {
        var n = this._x2 - t,
            r = this._y2 - e;
        this._l23_a = Math.sqrt(this._l23_2a = Math.pow(n * n + r * r, this._alpha));
      }

      switch (this._point) {
        case 0:
          this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
          break;

        case 1:
          this._point = 2;
          break;

        case 2:
          this._point = 3;

        default:
          ki(this, t, e);
      }

      this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
    }
  };

  var Ai = function t(e) {
    function n(t) {
      return e ? new Si(t, e) : new xi(t, 0);
    }

    return n.alpha = function (e) {
      return t(+e);
    }, n;
  }(.5);

  function Ei(t, e) {
    this._context = t, this._alpha = e;
  }

  Ei.prototype = {
    areaStart: hi,
    areaEnd: hi,
    lineStart: function lineStart() {
      this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function lineEnd() {
      switch (this._point) {
        case 1:
          this._context.moveTo(this._x3, this._y3), this._context.closePath();
          break;

        case 2:
          this._context.lineTo(this._x3, this._y3), this._context.closePath();
          break;

        case 3:
          this.point(this._x3, this._y3), this.point(this._x4, this._y4), this.point(this._x5, this._y5);
      }
    },
    point: function point(t, e) {
      if (t = +t, e = +e, this._point) {
        var n = this._x2 - t,
            r = this._y2 - e;
        this._l23_a = Math.sqrt(this._l23_2a = Math.pow(n * n + r * r, this._alpha));
      }

      switch (this._point) {
        case 0:
          this._point = 1, this._x3 = t, this._y3 = e;
          break;

        case 1:
          this._point = 2, this._context.moveTo(this._x4 = t, this._y4 = e);
          break;

        case 2:
          this._point = 3, this._x5 = t, this._y5 = e;
          break;

        default:
          ki(this, t, e);
      }

      this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
    }
  };

  var Ti = function t(e) {
    function n(t) {
      return e ? new Ei(t, e) : new bi(t, 0);
    }

    return n.alpha = function (e) {
      return t(+e);
    }, n;
  }(.5);

  function Di(t, e) {
    this._context = t, this._alpha = e;
  }

  Di.prototype = {
    areaStart: function areaStart() {
      this._line = 0;
    },
    areaEnd: function areaEnd() {
      this._line = NaN;
    },
    lineStart: function lineStart() {
      this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function lineEnd() {
      (this._line || 0 !== this._line && 3 === this._point) && this._context.closePath(), this._line = 1 - this._line;
    },
    point: function point(t, e) {
      if (t = +t, e = +e, this._point) {
        var n = this._x2 - t,
            r = this._y2 - e;
        this._l23_a = Math.sqrt(this._l23_2a = Math.pow(n * n + r * r, this._alpha));
      }

      switch (this._point) {
        case 0:
          this._point = 1;
          break;

        case 1:
          this._point = 2;
          break;

        case 2:
          this._point = 3, this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
          break;

        case 3:
          this._point = 4;

        default:
          ki(this, t, e);
      }

      this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = e;
    }
  };

  var Ni = function t(e) {
    function n(t) {
      return e ? new Di(t, e) : new wi(t, 0);
    }

    return n.alpha = function (e) {
      return t(+e);
    }, n;
  }(.5);

  function Ri(t) {
    this._context = t;
  }

  function Li(t) {
    return t < 0 ? -1 : 1;
  }

  function Pi(t, e, n) {
    var r = t._x1 - t._x0,
        i = e - t._x1,
        o = (t._y1 - t._y0) / (r || i < 0 && -0),
        a = (n - t._y1) / (i || r < 0 && -0),
        s = (o * i + a * r) / (r + i);
    return (Li(o) + Li(a)) * Math.min(Math.abs(o), Math.abs(a), .5 * Math.abs(s)) || 0;
  }

  function Oi(t, e) {
    var n = t._x1 - t._x0;
    return n ? (3 * (t._y1 - t._y0) / n - e) / 2 : e;
  }

  function Ui(t, e, n) {
    var r = t._x0,
        i = t._y0,
        o = t._x1,
        a = t._y1,
        s = (o - r) / 3;

    t._context.bezierCurveTo(r + s, i + s * e, o - s, a - s * n, o, a);
  }

  function Ii(t) {
    this._context = t;
  }

  function Vi(t) {
    this._context = new zi(t);
  }

  function zi(t) {
    this._context = t;
  }

  function ji(t) {
    return new Ii(t);
  }

  function Fi(t) {
    this._context = t;
  }

  function Bi(t) {
    var e,
        n,
        r = t.length - 1,
        i = new Array(r),
        o = new Array(r),
        a = new Array(r);

    for (i[0] = 0, o[0] = 2, a[0] = t[0] + 2 * t[1], e = 1; e < r - 1; ++e) {
      i[e] = 1, o[e] = 4, a[e] = 4 * t[e] + 2 * t[e + 1];
    }

    for (i[r - 1] = 2, o[r - 1] = 7, a[r - 1] = 8 * t[r - 1] + t[r], e = 1; e < r; ++e) {
      n = i[e] / o[e - 1], o[e] -= n, a[e] -= n * a[e - 1];
    }

    for (i[r - 1] = a[r - 1] / o[r - 1], e = r - 2; e >= 0; --e) {
      i[e] = (a[e] - i[e + 1]) / o[e];
    }

    for (o[r - 1] = (t[r] + i[r - 1]) / 2, e = 0; e < r - 1; ++e) {
      o[e] = 2 * t[e + 1] - i[e + 1];
    }

    return [i, o];
  }

  function Hi(t, e) {
    this._context = t, this._t = e;
  }

  Ri.prototype = {
    areaStart: hi,
    areaEnd: hi,
    lineStart: function lineStart() {
      this._point = 0;
    },
    lineEnd: function lineEnd() {
      this._point && this._context.closePath();
    },
    point: function point(t, e) {
      t = +t, e = +e, this._point ? this._context.lineTo(t, e) : (this._point = 1, this._context.moveTo(t, e));
    }
  }, Ii.prototype = {
    areaStart: function areaStart() {
      this._line = 0;
    },
    areaEnd: function areaEnd() {
      this._line = NaN;
    },
    lineStart: function lineStart() {
      this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN, this._point = 0;
    },
    lineEnd: function lineEnd() {
      switch (this._point) {
        case 2:
          this._context.lineTo(this._x1, this._y1);

          break;

        case 3:
          Ui(this, this._t0, Oi(this, this._t0));
      }

      (this._line || 0 !== this._line && 1 === this._point) && this._context.closePath(), this._line = 1 - this._line;
    },
    point: function point(t, e) {
      var n = NaN;

      if (e = +e, (t = +t) !== this._x1 || e !== this._y1) {
        switch (this._point) {
          case 0:
            this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
            break;

          case 1:
            this._point = 2;
            break;

          case 2:
            this._point = 3, Ui(this, Oi(this, n = Pi(this, t, e)), n);
            break;

          default:
            Ui(this, this._t0, n = Pi(this, t, e));
        }

        this._x0 = this._x1, this._x1 = t, this._y0 = this._y1, this._y1 = e, this._t0 = n;
      }
    }
  }, (Vi.prototype = Object.create(Ii.prototype)).point = function (t, e) {
    Ii.prototype.point.call(this, e, t);
  }, zi.prototype = {
    moveTo: function moveTo(t, e) {
      this._context.moveTo(e, t);
    },
    closePath: function closePath() {
      this._context.closePath();
    },
    lineTo: function lineTo(t, e) {
      this._context.lineTo(e, t);
    },
    bezierCurveTo: function bezierCurveTo(t, e, n, r, i, o) {
      this._context.bezierCurveTo(e, t, r, n, o, i);
    }
  }, Fi.prototype = {
    areaStart: function areaStart() {
      this._line = 0;
    },
    areaEnd: function areaEnd() {
      this._line = NaN;
    },
    lineStart: function lineStart() {
      this._x = [], this._y = [];
    },
    lineEnd: function lineEnd() {
      var t = this._x,
          e = this._y,
          n = t.length;
      if (n) if (this._line ? this._context.lineTo(t[0], e[0]) : this._context.moveTo(t[0], e[0]), 2 === n) this._context.lineTo(t[1], e[1]);else for (var r = Bi(t), i = Bi(e), o = 0, a = 1; a < n; ++o, ++a) {
        this._context.bezierCurveTo(r[0][o], i[0][o], r[1][o], i[1][o], t[a], e[a]);
      }
      (this._line || 0 !== this._line && 1 === n) && this._context.closePath(), this._line = 1 - this._line, this._x = this._y = null;
    },
    point: function point(t, e) {
      this._x.push(+t), this._y.push(+e);
    }
  }, Hi.prototype = {
    areaStart: function areaStart() {
      this._line = 0;
    },
    areaEnd: function areaEnd() {
      this._line = NaN;
    },
    lineStart: function lineStart() {
      this._x = this._y = NaN, this._point = 0;
    },
    lineEnd: function lineEnd() {
      0 < this._t && this._t < 1 && 2 === this._point && this._context.lineTo(this._x, this._y), (this._line || 0 !== this._line && 1 === this._point) && this._context.closePath(), this._line >= 0 && (this._t = 1 - this._t, this._line = 1 - this._line);
    },
    point: function point(t, e) {
      switch (t = +t, e = +e, this._point) {
        case 0:
          this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
          break;

        case 1:
          this._point = 2;

        default:
          if (this._t <= 0) this._context.lineTo(this._x, e), this._context.lineTo(t, e);else {
            var n = this._x * (1 - this._t) + t * this._t;
            this._context.lineTo(n, this._y), this._context.lineTo(n, e);
          }
      }

      this._x = t, this._y = e;
    }
  };
  var Yi = {
    strokeWidth: 2,
    stroke: "#6b6b6b",
    fill: "transparent",
    opacity: 1
  };

  function Wi(t) {
    var n = t.style,
        r = h(t, ["style"]),
        i = u({}, Yi, {}, n);
    return e.createElement("path", a({}, r, {
      style: i
    }));
  }

  var qi = li(),
      Xi = function Xi(t) {
    var n = t.children,
        r = h(t, ["children"]);
    return e.createElement("g", a({
      className: "Voronoi"
    }, r), n);
  };

  function Gi() {
    var t = y(e.useContext(x), 2),
        n = t[0],
        r = n.stackData,
        i = n.primaryAxes,
        o = n.secondaryAxes,
        a = n.showVoronoi,
        s = n.width,
        c = n.height,
        l = n.gridWidth,
        h = n.gridHeight,
        f = n.onFocus,
        d = n.onClick,
        p = n.tooltip,
        g = n.primaryCursor,
        m = n.secondaryCursor,
        _ = t[1],
        v = e.useCallback(function (t) {
      return _(function (e) {
        return u({}, e, {
          focused: t
        });
      });
    }, [_]),
        b = f || d || p || g || m;
    return e.useMemo(function () {
      if (!(r && i.length && o.length && s && c && b)) return null;
      var t = [[0, 0], [l, h]],
          n = null,
          u = [];
      return r.forEach(function (t) {
        t.datums.filter(function (t) {
          return t.defined;
        }).forEach(function (t) {
          t.boundingPoints.forEach(function (e) {
            "number" != typeof t.x || "number" != typeof t.y || Number.isNaN(t.y) || Number.isNaN(t.x) || u.push({
              x: e.x,
              y: e.y,
              datum: t
            });
          });
        });
      }), n = function () {
        var t = G,
            e = Z,
            n = null;

        function r(r) {
          return new Tt(r.map(function (n, i) {
            var o = [Math.round(t(n, i, r) / St) * St, Math.round(e(n, i, r) / St) * St];
            return o.index = i, o.data = n, o;
          }), n);
        }

        return r.polygons = function (t) {
          return r(t).polygons();
        }, r.links = function (t) {
          return r(t).links();
        }, r.triangles = function (t) {
          return r(t).triangles();
        }, r.x = function (e) {
          return arguments.length ? (t = "function" == typeof e ? e : X(+e), r) : t;
        }, r.y = function (t) {
          return arguments.length ? (e = "function" == typeof t ? t : X(+t), r) : e;
        }, r.extent = function (t) {
          return arguments.length ? (n = null == t ? null : [[+t[0][0], +t[0][1]], [+t[1][0], +t[1][1]]], r) : n && [[n[0][0], n[0][1]], [n[1][0], n[1][1]]];
        }, r.size = function (t) {
          return arguments.length ? (n = null == t ? null : [[0, 0], [+t[0], +t[1]]], r) : n && [n[1][0] - n[0][0], n[1][1] - n[0][1]];
        }, r;
      }().x(function (t) {
        return t.x;
      }).y(function (t) {
        return t.y;
      }).extent(t)(u).polygons(), e.createElement(Xi, null, n.map(function (t, n) {
        var r = qi(t);
        return e.createElement(Wi, {
          key: n,
          d: r,
          className: "action-voronoi",
          onMouseEnter: function onMouseEnter(e) {
            return v(t.data.datum);
          },
          onMouseLeave: function onMouseLeave(t) {
            return v(null);
          },
          style: {
            fill: "rgba(0,0,0,.2)",
            stroke: "rgba(255,255,255,.5)",
            opacity: a ? 1 : 0
          }
        });
      }));
    }, [h, l, c, v, i.length, o.length, a, r, s]);
  }

  var Zi = {
    strokeWidth: 1,
    fill: "transparent",
    opacity: 1
  },
      $i = function (t) {
    !function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          writable: !0,
          configurable: !0
        }
      }), e && l(t, e);
    }(f, t);
    var n,
        o,
        s,
        c = d(f);

    function f() {
      return r(this, f), c.apply(this, arguments);
    }

    return n = f, (o = [{
      key: "render",
      value: function value() {
        var t = this.props,
            n = t.style,
            r = h(t, ["style"]),
            i = u({}, Zi, {}, n);
        return e.createElement("line", a({}, r, {
          style: i
        }));
      }
    }]) && i(n.prototype, o), s && i(n, s), f;
  }(e.Component),
      Ki = {
    fontFamily: "Helvetica",
    fontSize: 10,
    opacity: 1
  };

  function Ji(t) {
    var n = t.style,
        r = (t.opacity, h(t, ["style", "opacity"])),
        i = u({}, Ki, {}, n);
    return e.createElement("text", a({}, r, {
      style: i
    }));
  }

  var Qi = e.forwardRef(function (t, n) {
    return e.createElement("g", a({}, t, {
      ref: n
    }));
  }),
      to = "top",
      eo = "right",
      no = "left",
      ro = "single",
      io = "series",
      oo = "primary",
      ao = "secondary",
      so = {
    line: {
      strokeWidth: "1",
      fill: "transparent"
    },
    tick: {
      fontSize: 10,
      fontFamily: "sans-serif"
    }
  };

  function uo(t) {
    var n,
        r,
        i = t.id,
        a = t.type,
        s = t.position,
        c = t.tickSizeInner,
        l = t.tickSizeOuter,
        h = t.show,
        f = t.showGrid,
        d = t.showTicks,
        g = t.styles,
        m = t.maxLabelRotation,
        _ = t.labelRotationStep,
        b = t.tickPadding,
        M = t.ticks,
        w = t.tickCount,
        C = t.minTickCount,
        k = t.maxTickCount,
        S = t.scale,
        A = t.max,
        E = t.transform,
        T = t.vertical,
        D = t.format,
        N = y(t.range, 2),
        R = N[0],
        P = N[1],
        O = t.directionMultiplier,
        U = t.tickOffset,
        I = t.gridOffset,
        V = t.spacing,
        z = y(e.useState(0), 2),
        j = z[0],
        F = z[1],
        B = y(e.useContext(x), 2),
        H = B[0],
        Y = H.gridWidth,
        W = H.gridHeight,
        q = H.dark,
        X = H.axisDimensions,
        G = B[1],
        Z = e.useRef(),
        $ = e.useRef(),
        K = e.useCallback(function () {
      if (Z.current) {
        var t = Array.apply(void 0, p(Z.current.querySelectorAll(".tickLabel"))).map(function (t) {
          var e = t.getBoundingClientRect();
          return {
            width: e.width,
            height: e.height
          };
        }),
            e = T ? W : Y,
            n = w,
            r = 0,
            h = 0,
            f = 0,
            d = 0,
            y = 1e5;
        Array.apply(void 0, p(Z.current.querySelectorAll(".tick"))).map(function (t) {
          return t.getBoundingClientRect();
        }).reduce(function (t, e) {
          if (t) {
            var n = T ? e.top - t.top : e.left - t.left;
            y = n < y ? n : y;
          }

          return e;
        }, !1);
        var g = t[0] || {
          width: 0,
          height: 0
        },
            x = t[t.length - 1] || {
          width: 0,
          height: 0
        },
            v = u({}, g, {
          _overflow: 0
        });
        t.forEach(function (t) {
          t._overflow = T ? t.height - y : t.width, t._overflow > 0 && t._overflow > v._overflow && (v = t);
        });
        var M = T ? v.height : v.width;

        if (!T && "ordinal" === a || "auto" !== w) {
          if (!T) {
            var S = Math.min(Math.max(Math.abs(function (t) {
              return t * (180 / Math.PI);
            }(Math.acos(y / (v.width + b)))), 0), m);
            S = Number.isNaN(S) ? 0 : S, (0 === (S = Math.ceil(Math.ceil(S / _) * _)) || S === m || Math.abs(S) - Math.abs(j) > 5) && F(function () {
              return "top" === s ? -S : S;
            });
          }
        } else n = Math.max(C, Math.min(Math.floor((e + M - b) / (M + 2 * b)), k));

        var A = Math.ceil(b / y);
        $.current !== A && ($.current = A), T ? (f = Math.ceil(g.height / 2), d = Math.ceil(x.height / 2), r = Math.max(c, l) + b + Math.max.apply(Math, [0].concat(p(t.map(function (t) {
          return Math.ceil(t.width);
        }))))) : h = Math.max(c, l) + b + Math.max.apply(Math, [0].concat(p(t.map(function (t) {
          return Math.ceil(t.height);
        }))));
        var E = {
          width: r,
          height: h,
          top: f,
          bottom: d,
          left: 0,
          right: 0,
          tickCount: n
        };
        X && X[s] && X[s][i] && !Object.keys(E).some(function (t) {
          return E[t] !== X[s][i][t];
        }) || G(function (t) {
          return u({}, t, {
            axisDimensions: u({}, t.axisDimensions, o({}, s, u({}, t.axisDimensions[s] || {}, o({}, i, E))))
          });
        });
      } else X[s] && X[s][i] && G(function (t) {
        var e = t.axisDimensions[s] || {};
        return delete e[i], u({}, t, {
          axisDimensions: u({}, t.axisDimensions, o({}, s, e))
        });
      });
    }, [X, W, Y, i, _, m, k, C, s, j, G, w, b, c, l, a, T]),
        J = L(j);
    if (e.useLayoutEffect(function () {
      J === j && K();
    }, [X, i, K, s, J, j]), e.useEffect(function () {
      J !== j && K();
    }, [X, i, K, s, J, j]), !h) return null;
    n = T ? s === no ? "\n        M ".concat(-l, ", ").concat(R, "\n        H 0\n        V ").concat(P, "\n        H ").concat(-l, "\n      ") : "\n        M ".concat(l, ", ").concat(R, "\n        H 0\n        V ").concat(P, "\n        H ").concat(l, "\n      ") : "bottom" === s ? "\n        M 0, ".concat(l, "\n        V 0\n        H ").concat(P, "\n        V ").concat(l, "\n      ") : "\n        M 0, ".concat(-l, "\n        V 0\n        H ").concat(P, "\n        V ").concat(-l, "\n              "), r = "boolean" == typeof f ? f : "ordinal" !== a;
    var Q = u({}, so, {}, g);
    return e.createElement(Qi, {
      ref: Z,
      className: "Axis",
      style: {
        pointerEvents: "none",
        transform: s === eo ? v.translateX(Y) : "bottom" === s ? v.translateY(W) : void 0
      }
    }, e.createElement(Wi, {
      className: "domain",
      d: n,
      style: u({
        stroke: q ? "rgba(255,255,255, .1)" : "rgba(0,0,0, .1)"
      }, Q.line)
    }), e.createElement(Qi, {
      className: "ticks",
      style: {}
    }, M.map(function (t, n) {
      return e.createElement(Qi, {
        key: [String(t), n].join("_"),
        className: "tick",
        style: {
          transform: E(S(t) || 0)
        }
      }, r && e.createElement($i, {
        className: "gridLine",
        x1: T ? 0 : I,
        x2: T ? A : I,
        y1: T ? I : 0,
        y2: T ? I : A,
        style: u({
          stroke: q ? "rgba(255,255,255, .1)" : "rgba(0,0,0, .1)",
          strokeWidth: 1
        }, Q.line)
      }), d ? e.createElement("g", {
        className: "labelGroup"
      }, e.createElement($i, {
        className: "tickline",
        x1: T ? 0 : U,
        x2: T ? O * c : U,
        y1: T ? U : 0,
        y2: T ? U : O * c,
        style: u({
          stroke: q ? "rgba(255,255,255, .1)" : "rgba(0,0,0, .1)",
          strokeWidth: 1
        }, Q.line)
      }), e.createElement(Ji, {
        className: "tickLabel",
        style: u({
          fill: q ? "white" : "black"
        }, Q.tick, {
          transform: "".concat(v.translate(T ? O * V : U, T ? U : O * V), " rotate(").concat(-j, "deg)")
        }),
        dominantBaseline: j ? "central" : "bottom" === s ? "hanging" : s === to ? "alphabetic" : "central",
        textAnchor: j ? "end" : s === eo ? "start" : s === no ? "end" : "middle"
      }, D(t, n))) : null);
    })));
  }

  function co(t) {
    return e.createElement(uo, t);
  }

  var lo = function lo(t) {
    return t ? "rgba(255,255,255,.9)" : "rgba(0, 26, 39, 0.9)";
  };

  function ho() {
    var t = y(e.useContext(x), 1)[0],
        n = t.primaryAxes,
        r = t.secondaryAxes,
        i = t.gridX,
        o = t.gridY,
        a = t.gridWidth,
        s = t.gridHeight,
        c = t.dark,
        l = t.focused,
        h = t.latestFocused,
        f = t.getDatumStyle,
        d = t.tooltip,
        p = e.useRef(),
        g = e.useRef(),
        m = e.useRef(),
        _ = d || {},
        b = _.align,
        M = _.alignPriority,
        w = _.padding,
        C = _.tooltipArrowPadding,
        k = _.arrowPosition,
        S = _.render,
        A = _.anchor,
        E = _.show,
        T = y(e.useState(b || "auto"), 2),
        D = T[0],
        N = T[1];

    if (e.useEffect(function () {
      m.current = E;
    }, [E]), e.useLayoutEffect(function () {
      if ("auto" === b && p.current && E && A) {
        for (var t = {
          left: 1 / 0,
          top: 1 / 0,
          right: 1 / 0,
          bottom: 1 / 0
        }, e = p.current, n = e.getBoundingClientRect(), r = g.current.getBoundingClientRect(); e !== document.body;) {
          e = e.parentElement;
          var i = window.getComputedStyle(e),
              o = i.overflowX,
              a = i.overflowY;

          if (e === document.body || [o, a].find(function (t) {
            return ["auto", "hidden"].includes(t);
          })) {
            var s = e.getBoundingClientRect(),
                u = n.left - s.left + A.x,
                c = n.top - s.top + A.y,
                l = s.width - u,
                h = s.height - c;
            t.left = Math.min(t.left, u), t.top = Math.min(t.top, c), t.right = Math.min(t.right, l), t.bottom = Math.min(t.bottom, h);
          }
        }

        var f = null;
        M.forEach(function (e) {
          if (!f) {
            var n = t.left - C - w - A.horizontalPadding > r.width,
                i = t.right - C - w - A.horizontalPadding > r.width,
                o = t.top - C - w - A.verticalPadding > r.height && t.left > r.width / 2,
                a = t.bottom - C - w - A.verticalPadding > r.height,
                s = t.left > r.width / 2,
                u = t.right > r.width / 2,
                c = t.top > r.height / 2,
                l = t.bottom > r.height / 2;
            "left" === e ? n && c && l && (f = e) : "right" === e ? i && c && l && (f = e) : "top" === e ? o && s && u && (f = e) : "bottom" === e ? a && s && u && (f = e) : "topLeft" === e ? o && n && (f = e) : "topRight" === e ? o && i && (f = e) : "bottomLeft" === e ? a && n && (f = e) : "bottomRight" === e && a && i && (f = e);
          }
        }), f !== D && N(f);
      }
    }, [b, M, A, D, w, E, C]), !d) return null;
    var R = l || h,
        L = 0,
        P = -50,
        O = {},
        U = lo(c),
        I = k;
    "top" === D ? (L = -50, P = -100) : "topRight" === D ? (L = 0, P = -100) : "right" === D ? (L = 0, P = -50) : "bottomRight" === D ? (L = 0, P = 0) : "bottom" === D ? (L = -50, P = 0) : "bottomLeft" === D ? (L = -100, P = 0) : "left" === D ? (L = -100, P = -50) : "topLeft" === D ? (L = -100, P = -100) : "center" === D && (L = -50, P = -50), I || ("left" === D ? I = "right" : "right" === D ? I = "left" : "top" === D ? I = "bottom" : "bottom" === D ? I = "top" : "topRight" === D ? I = "bottomLeft" : "bottomRight" === D ? I = "topLeft" : "topLeft" === D ? I = "bottomRight" : "bottomLeft" === D && (I = "topRight")), O = "bottom" === I ? {
      top: "100%",
      left: "50%",
      transform: "translate3d(-50%, 0%, 0)",
      borderLeft: "".concat(7 * .8, "px solid transparent"),
      borderRight: "".concat(7 * .8, "px solid transparent"),
      borderTop: "".concat(7, "px solid ").concat(U)
    } : "top" === I ? {
      top: "0%",
      left: "50%",
      transform: "translate3d(-50%, -100%, 0)",
      borderLeft: "".concat(7 * .8, "px solid transparent"),
      borderRight: "".concat(7 * .8, "px solid transparent"),
      borderBottom: "".concat(7, "px solid ").concat(U)
    } : "right" === I ? {
      top: "50%",
      left: "100%",
      transform: "translate3d(0%, -50%, 0)",
      borderTop: "".concat(7 * .8, "px solid transparent"),
      borderBottom: "".concat(7 * .8, "px solid transparent"),
      borderLeft: "".concat(7, "px solid ").concat(U)
    } : "left" === I ? {
      top: "50%",
      left: "0%",
      transform: "translate3d(-100%, -50%, 0)",
      borderTop: "".concat(7 * .8, "px solid transparent"),
      borderBottom: "".concat(7 * .8, "px solid transparent"),
      borderRight: "".concat(7, "px solid ").concat(U)
    } : "topRight" === I ? {
      top: "0%",
      left: "100%",
      transform: "translate3d(-50%, -50%, 0) rotate(-45deg)",
      borderTop: "".concat(7 * .8, "px solid transparent"),
      borderBottom: "".concat(7 * .8, "px solid transparent"),
      borderLeft: "".concat(14, "px solid ").concat(U)
    } : "bottomRight" === I ? {
      top: "100%",
      left: "100%",
      transform: "translate3d(-50%, -50%, 0) rotate(45deg)",
      borderTop: "".concat(7 * .8, "px solid transparent"),
      borderBottom: "".concat(7 * .8, "px solid transparent"),
      borderLeft: "".concat(14, "px solid ").concat(U)
    } : "topLeft" === I ? {
      top: "0%",
      left: "0%",
      transform: "translate3d(-50%, -50%, 0) rotate(45deg)",
      borderTop: "".concat(7 * .8, "px solid transparent"),
      borderBottom: "".concat(7 * .8, "px solid transparent"),
      borderRight: "".concat(14, "px solid ").concat(U)
    } : "bottomLeft" === I ? {
      top: "100%",
      left: "0%",
      transform: "translate3d(-50%, -50%, 0) rotate(-45deg)",
      borderTop: "".concat(7 * .8, "px solid transparent"),
      borderBottom: "".concat(7 * .8, "px solid transparent"),
      borderRight: "".concat(14, "px solid ").concat(U)
    } : {
      opacity: 0
    };
    var V,
        z = v.getAxisByAxisID(n, R ? R.series.primaryAxisID : null),
        j = v.getAxisByAxisID(r, R ? R.series.secondaryAxisID : null),
        F = w + A.horizontalPadding,
        B = w + A.verticalPadding,
        H = u({}, t, {}, t.tooltip, {
      datum: R,
      getStyle: function getStyle(t) {
        return t.getStatusStyle(R, f);
      },
      primaryAxis: z,
      secondaryAxis: j
    }),
        Y = e.createElement(S, H);
    return m.current === E && (V = !0), e.createElement("div", {
      className: "tooltip-wrap",
      style: {
        pointerEvents: "none",
        position: "absolute",
        left: "".concat(i, "px"),
        top: "".concat(o, "px"),
        width: "".concat(a, "px"),
        height: "".concat(s, "px"),
        opacity: E ? 1 : 0,
        transition: "all .3s ease"
      },
      ref: function ref(t) {
        p.current = t;
      }
    }, e.createElement("div", {
      style: {
        position: "absolute",
        left: 0,
        top: 0,
        transform: v.translate(A.x, A.y),
        transition: V ? "all .2s ease" : "opacity .2s ease"
      }
    }, e.createElement("div", {
      style: {
        transform: "translate3d(".concat(L, "%, ").concat(P, "%, 0)"),
        padding: "".concat(C + B, "px ").concat(C + F, "px"),
        width: "auto",
        transition: "all .2s ease"
      }
    }, e.createElement("div", {
      ref: function ref(t) {
        g.current = t;
      },
      style: {
        fontSize: "12px",
        padding: "5px",
        background: lo(c),
        color: c ? "black" : "white",
        borderRadius: "3px",
        position: "relative"
      }
    }, e.createElement("div", {
      style: u({
        position: "absolute",
        width: 0,
        height: 0
      }, O, {
        transition: V ? "all .2s ease" : "none"
      })
    }), Y))));
  }

  var fo = function fo(t) {
    return t ? "rgba(255,255,255,.3)" : "rgba(0, 26, 39, 0.3)";
  },
      yo = function yo(t) {
    return t ? "rgba(255,255,255,.9)" : "rgba(0, 26, 39, 0.9)";
  };

  function po(t) {
    var n = t.primary,
        r = y(e.useContext(x), 1)[0],
        i = r.primaryCursor,
        o = r.secondaryCursor,
        a = r.focused,
        s = r.latestFocused,
        c = r.gridX,
        l = r.gridY,
        h = r.dark,
        f = a || s,
        d = n ? i : o,
        p = d || {},
        g = p.showLine,
        m = p.showLabel,
        _ = p.resolvedValue,
        b = p.snap,
        M = p.render,
        w = p.axis,
        C = p.siblingAxis,
        k = p.resolvedShow,
        S = R(_, void 0 !== _),
        A = e.useRef();
    if (e.useEffect(function () {
      A.current = k;
    }, [k]), !d) return null;
    var E,
        T,
        D,
        N,
        L,
        P,
        O,
        U,
        I = b || "ordinal" === w.type,
        V = C.scale.range();
    w.vertical ? (T = w.scale(S), D = V[0], N = V[1], L = T - 1, P = T + w.cursorSize + 1, "left" === w.position ? (O = -100, U = -50) : (O = 0, U = -50)) : (D = (E = w.scale(S)) - 1, N = E + w.cursorSize + 1, L = V[0], P = V[1], "top" === w.position ? (O = -500, U = -100) : (O = -50, U = 0));
    var z = u({}, d);
    z.formattedValue = String((w.vertical, void 0 !== S ? w.format(w.stacked && !n && f ? f.totalValue : S) : ""));
    var j,
        F = Math.min(D, N),
        B = Math.min(L, P),
        H = Math.max(D, N),
        Y = Math.max(L, P),
        W = w.vertical && w.RTL ? H : D + (w.vertical ? 0 : (N - D) / 2) + (w.vertical ? 0 : 1),
        q = !w.vertical && w.RTL ? B : L + (w.vertical ? (P - L) / 2 : 0) + (w.vertical ? 1 : 0),
        X = Math.max(Y - B, 0),
        G = Math.max(H - F, 0);
    A.current === k && (j = !0);
    var Z = M(z);
    return e.createElement("div", {
      style: {
        pointerEvents: "none",
        position: "absolute",
        top: 0,
        left: 0,
        transform: v.translate(c, l),
        opacity: k ? 1 : 0,
        transition: "all .3s ease"
      },
      className: "Cursor"
    }, g ? e.createElement("div", {
      style: {
        position: "absolute",
        top: 0,
        left: 0,
        transform: v.translate(F, B),
        width: "".concat(G, "px"),
        height: "".concat(X, "px"),
        background: fo(h),
        transition: I && j ? "all .2s ease" : "opacity .2s ease"
      }
    }) : null, m ? e.createElement("div", {
      style: {
        position: "absolute",
        top: 0,
        left: 0,
        transform: v.translate(W, q),
        transition: I && j ? "all .2s ease" : "opacity .2s ease"
      }
    }, e.createElement("div", {
      style: {
        padding: "5px",
        fontSize: "10px",
        background: yo(h),
        color: yo(!h),
        borderRadius: "3px",
        position: "relative",
        transform: "translate3d(".concat(O, "%, ").concat(U, "%, 0)"),
        whiteSpace: "nowrap"
      }
    }, Z)) : null);
  }

  function go() {
    var t = y(e.useContext(x), 1)[0],
        n = t.pointer,
        r = t.brush,
        i = t.gridX,
        o = t.gridY,
        a = t.gridHeight,
        s = t.dark;
    return r ? e.createElement("div", {
      className: "Brush",
      style: {
        pointerEvents: "none",
        position: "absolute",
        left: 0,
        top: 0,
        transform: v.translate(i, o),
        opacity: n.dragging ? Math.abs(n.sourceX - n.x) < 20 ? .5 : 1 : 0
      }
    }, e.createElement("div", {
      style: u({
        position: "absolute",
        transform: v.translate(Math.min(n.x, n.sourceX), 0),
        width: "".concat(Math.abs(n.x - n.sourceX), "px"),
        height: "".concat(a, "px"),
        background: s ? "rgba(255,255,255,.3)" : "rgba(0, 26, 39, 0.3)"
      }, r.style)
    })) : null;
  }

  var mo = e.forwardRef(function (t, n) {
    var r = t.className,
        i = t.style,
        o = void 0 === i ? {} : i,
        s = h(t, ["className", "style"]),
        c = y(e.useContext(x), 1)[0],
        l = y(e.useContext(x), 2),
        f = l[0],
        d = f.width,
        g = f.height,
        m = f.offset,
        _ = f.gridX,
        b = f.gridY,
        M = f.stackData,
        w = f.primaryAxes,
        C = f.secondaryAxes,
        k = f.renderSVG,
        S = f.onClick,
        A = f.seriesOptions,
        E = f.getSeriesOrder,
        T = f.focused,
        D = l[1],
        N = e.useRef();
    e.useLayoutEffect(function () {
      if (N.current) {
        var t = N.current.getBoundingClientRect();
        t.left === m.left && t.top === m.top || D(function (e) {
          return u({}, e, {
            offset: {
              left: t.left,
              top: t.top
            }
          });
        });
      }
    });

    var R = e.useRef(),
        L = function L(t) {
      R.current && Y.cancel(R.current), R.current = Y(function () {
        R.current = null;
        var e = t.clientX,
            n = t.clientY;
        D(function (t) {
          var r = e - m.left - _,
              i = n - m.top - b,
              o = u({}, t.pointer, {
            active: !0,
            x: r,
            y: i,
            dragging: t.pointer && t.pointer.down
          });
          return u({}, t, {
            pointer: o
          });
        });
      });
    },
        P = function t() {
      document.removeEventListener("mouseup", t), document.removeEventListener("mousemove", L), D(function (t) {
        return u({}, t, {
          pointer: u({}, t.pointer, {
            down: !1,
            dragging: !1,
            released: {
              x: t.pointer.x,
              y: t.pointer.y
            }
          })
        });
      });
    },
        O = E(p(M).reverse()),
        U = T ? O.findIndex(function (t) {
      return t.id === T.series.id;
    }) : -1,
        I = (T ? [].concat(p(O.slice(0, U)), p(O.slice(U + 1)), [O[U]]) : O).map(function (t) {
      return e.createElement(t.Component, a({
        key: t.id
      }, A[t.index], {
        series: t,
        stackData: M
      }));
    });

    return e.createElement("div", a({
      ref: n
    }, s, {
      className: "ReactChart ".concat(r || ""),
      style: u({
        width: d,
        height: g,
        position: "relative"
      }, o)
    }), e.createElement("svg", {
      ref: N,
      style: {
        width: d,
        height: g,
        overflow: "hidden"
      },
      onMouseEnter: function onMouseEnter(t) {
        return t.persist() || L(t);
      },
      onMouseMove: function onMouseMove(t) {
        return t.persist() || L(t);
      },
      onMouseLeave: function onMouseLeave(t) {
        return t.persist() || (D(function (t) {
          return u({}, t, {
            focused: null
          });
        }), void D(function (t) {
          return u({}, t, {
            pointer: u({}, t.pointer, {
              active: !1
            })
          });
        }));
      },
      onMouseDown: function onMouseDown(t) {
        return t.persist() || (document.addEventListener("mouseup", P), document.addEventListener("mousemove", L), void D(function (t) {
          return u({}, t, {
            pointer: u({}, t.pointer, {
              sourceX: t.pointer.x,
              sourceY: t.pointer.y,
              down: !0
            })
          });
        }));
      },
      onClick: S
    }, e.createElement("g", {
      style: {
        transform: v.translate(_, b)
      }
    }, e.createElement(q, {
      x1: -_,
      x2: d - _,
      y1: -b,
      y2: g - b,
      style: {
        opacity: 0
      }
    }), e.createElement(Gi, null), e.createElement("g", {
      className: "axes"
    }, [].concat(p(w), p(C)).map(function (t) {
      return e.createElement(co, a({
        key: t.id
      }, t));
    })), e.createElement("g", {
      className: "Series",
      style: {
        pointerEvents: "none"
      }
    }, I)), k ? k({
      chartState: c,
      setChartState: D
    }) : null), e.createElement(po, {
      primary: !0
    }), e.createElement(po, null), e.createElement(go, null), e.createElement(ho, null));
  });

  function _o(t) {
    var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        r = e.useRef({
      style: {},
      props: {}
    }),
        i = e.useRef(),
        o = n.style,
        a = void 0 === o ? {} : o,
        s = h(n, ["style"]);
    return (v.shallowDiff(r.current.style, a) || v.shallowDiff(r.current.props, s)) && (r.current = n, i.current = t()), i.current;
  }

  function xo(t) {
    var n = y(e.useContext(x), 1)[0],
        r = n.focused,
        i = n.getSeriesStyle;
    return t.getStatusStyle(r, i);
  }

  function vo(t) {
    var n = y(e.useContext(x), 1)[0],
        r = n.focused,
        i = n.getDatumStyle;
    return t.getStatusStyle(r, i);
  }

  var bo = {
    r: 2,
    strokeWidth: "1",
    stroke: "#000000",
    fill: "#000000",
    opacity: 1
  };

  function Mo(t) {
    var n = t.x,
        r = t.y,
        i = (t.r, t.style),
        o = h(t, ["x", "y", "r", "style"]),
        s = u({}, bo, {}, i);
    return e.createElement("circle", a({}, o, {
      cx: n || 0,
      cy: r || 0,
      r: 1,
      style: s
    }));
  }

  var wo = {
    strokeWidth: 2
  },
      Co = {
    r: 2
  };

  function ko(t) {
    var n = t.series,
        r = t.showPoints,
        i = t.curve,
        o = e.useMemo(function () {
      return li().x(function (t) {
        return t.x;
      }).y(function (t) {
        return t.y;
      }).defined(function (t) {
        return t.defined;
      }).curve(i);
    }, [i]),
        a = e.useMemo(function () {
      return o(n.datums);
    }, [o, n.datums]),
        s = xo(n),
        c = {
      d: a,
      style: u({}, wo, {}, s, {}, s.line, {
        fill: "none"
      })
    },
        l = _o(function () {
      return e.createElement(Wi, c);
    }, c);

    return e.useMemo(function () {
      return e.createElement("g", null, l, r && n.datums.map(function (t, n) {
        return e.createElement(So, {
          key: n,
          datum: t,
          style: s
        });
      }));
    }, [l, n.datums, r, s]);
  }

  function So(t) {
    var n = t.datum,
        r = t.style,
        i = y(e.useContext(x), 2)[1],
        o = vo(n),
        a = {
      x: n ? n.x : void 0,
      y: n ? n.y : void 0,
      style: u({}, Co, {}, r, {}, r.circle, {}, o, {}, o.circle),
      onMouseEnter: function onMouseEnter(t) {
        return i(function (t) {
          return u({}, t, {
            element: n
          });
        });
      },
      onMouseLeave: function onMouseLeave(t) {
        return i(function (t) {
          return u({}, t, {
            element: null
          });
        });
      }
    };
    return _o(function () {
      return n.defined ? e.createElement(Mo, a) : null;
    }, a);
  }

  ko.defaultProps = {
    curve: ji
  }, ko.plotDatum = function (t, e) {
    var n = e.primaryAxis,
        r = e.secondaryAxis,
        i = e.xAxis,
        o = e.yAxis;
    t.primaryCoord = n.scale(t.primary), t.secondaryCoord = r.scale(t.secondary), t.x = i.scale(t.xValue), t.y = o.scale(t.yValue), t.defined = v.isValidPoint(t.xValue) && v.isValidPoint(t.yValue), t.base = n.vertical ? i.scale(t.baseValue) : o.scale(t.baseValue), "ordinal" === i.type && (t.x += i.tickOffset), "ordinal" === o.type && (t.y += o.tickOffset), t.anchor = {
      x: t.x,
      y: t.y
    }, t.boundingPoints = [t.anchor];
  }, ko.buildStyles = function (t, e) {
    var n = e.defaultColors,
        r = {
      color: n[t.index % (n.length - 1)]
    };
    v.buildStyleGetters(t, r);
  };
  var Ao = {
    r: 2
  };

  function Eo(t) {
    var n = t.series,
        r = xo(n);
    return e.createElement("g", null, n.datums.map(function (t, n) {
      return e.createElement(To, {
        key: n,
        datum: t,
        style: r
      });
    }));
  }

  function To(t) {
    var n = t.datum,
        r = t.style,
        i = vo(n),
        o = y(e.useContext(x), 2)[1],
        a = {
      x: n ? n.x : void 0,
      y: n ? n.y : void 0,
      style: u({}, Ao, {}, void 0 !== n.r ? {
        r: n.r
      } : {}, {}, r, {}, r.circle, {}, i, {}, i.circle),
      onMouseEnter: function onMouseEnter(t) {
        return o(function (t) {
          return u({}, t, {
            element: n
          });
        });
      },
      onMouseLeave: function onMouseLeave(t) {
        return o(function (t) {
          return u({}, t, {
            element: null
          });
        });
      }
    };
    return _o(function () {
      return n.defined ? e.createElement(Mo, a) : null;
    }, a);
  }

  Eo.plotDatum = function (t, e) {
    var n = e.primaryAxis,
        r = e.secondaryAxis,
        i = e.xAxis,
        o = e.yAxis;
    t.primaryCoord = n.scale(t.primary), t.secondaryCoord = r.scale(t.secondary), t.x = i.scale(t.xValue), t.y = o.scale(t.yValue), t.defined = v.isValidPoint(t.xValue) && v.isValidPoint(t.yValue), t.base = n.vertical ? i.scale(t.baseValue) : o.scale(t.baseValue), "ordinal" === i.type && (t.x += i.tickOffset), "ordinal" === o.type && (t.y += o.tickOffset), t.anchor = {
      x: t.x,
      y: t.y,
      verticalPadding: t.r,
      horizontalPadding: t.r
    }, t.boundingPoints = [t.anchor];
  }, Eo.buildStyles = function (t, e) {
    var n = e.defaultColors,
        r = {
      color: n[t.index % (n.length - 1)]
    };
    v.buildStyleGetters(t, r);
  };
  var Do = {
    strokeWidth: 0
  },
      No = {
    strokeWidth: 3
  };

  function Ro(t) {
    var n = t.series,
        r = t.showOrphans,
        i = t.curve,
        o = e.useMemo(function () {
      return function () {
        var t = ui,
            e = null,
            n = oi(0),
            r = ci,
            i = oi(!0),
            o = null,
            a = si,
            s = null;

        function u(u) {
          var c,
              l,
              h,
              f,
              d,
              y = u.length,
              p = !1,
              g = new Array(y),
              m = new Array(y);

          for (null == o && (s = a(d = ii())), c = 0; c <= y; ++c) {
            if (!(c < y && i(f = u[c], c, u)) === p) if (p = !p) l = c, s.areaStart(), s.lineStart();else {
              for (s.lineEnd(), s.lineStart(), h = c - 1; h >= l; --h) {
                s.point(g[h], m[h]);
              }

              s.lineEnd(), s.areaEnd();
            }
            p && (g[c] = +t(f, c, u), m[c] = +n(f, c, u), s.point(e ? +e(f, c, u) : g[c], r ? +r(f, c, u) : m[c]));
          }

          if (d) return s = null, d + "" || null;
        }

        function c() {
          return li().defined(i).curve(a).context(o);
        }

        return u.x = function (n) {
          return arguments.length ? (t = "function" == typeof n ? n : oi(+n), e = null, u) : t;
        }, u.x0 = function (e) {
          return arguments.length ? (t = "function" == typeof e ? e : oi(+e), u) : t;
        }, u.x1 = function (t) {
          return arguments.length ? (e = null == t ? null : "function" == typeof t ? t : oi(+t), u) : e;
        }, u.y = function (t) {
          return arguments.length ? (n = "function" == typeof t ? t : oi(+t), r = null, u) : n;
        }, u.y0 = function (t) {
          return arguments.length ? (n = "function" == typeof t ? t : oi(+t), u) : n;
        }, u.y1 = function (t) {
          return arguments.length ? (r = null == t ? null : "function" == typeof t ? t : oi(+t), u) : r;
        }, u.lineX0 = u.lineY0 = function () {
          return c().x(t).y(n);
        }, u.lineY1 = function () {
          return c().x(t).y(r);
        }, u.lineX1 = function () {
          return c().x(e).y(n);
        }, u.defined = function (t) {
          return arguments.length ? (i = "function" == typeof t ? t : oi(!!t), u) : i;
        }, u.curve = function (t) {
          return arguments.length ? (a = t, null != o && (s = a(o)), u) : a;
        }, u.context = function (t) {
          return arguments.length ? (null == t ? o = s = null : s = a(o = t), u) : o;
        }, u;
      }().x(function (t) {
        return t.x;
      }).y0(function (t) {
        return t.base;
      }).y1(function (t) {
        return t.y;
      }).defined(function (t) {
        return t.defined;
      }).curve(i);
    }, [i]),
        a = e.useMemo(function () {
      return li().x(function (t) {
        return t.x;
      }).y(function (t) {
        return t.y;
      }).defined(function (t) {
        return t.defined;
      }).curve(i);
    }, [i]),
        s = e.useMemo(function () {
      return o(n.datums);
    }, [o, n.datums]),
        c = e.useMemo(function () {
      return a(n.datums);
    }, [a, n.datums]),
        l = xo(n),
        h = {
      d: s,
      style: u({}, Do, {}, l, {}, l.line, {}, l.area)
    },
        f = _o(function () {
      return e.createElement(Wi, h);
    }, h),
        d = {
      d: c,
      style: u({}, Do, {}, l, {}, l.line, {
        fill: "none"
      })
    },
        y = _o(function () {
      return e.createElement(Wi, d);
    }, d);

    return e.createElement("g", null, f, y, r && n.datums.map(function (t, n, r) {
      return e.createElement(Lo, {
        key: n,
        datum: t,
        style: l,
        all: r,
        index: n
      });
    }));
  }

  Ro.defaultProps = {
    showOrphans: !0,
    curve: si
  }, Ro.plotDatum = function (t, e) {
    var n = e.primaryAxis,
        r = e.secondaryAxis,
        i = e.xAxis,
        o = e.yAxis;
    r.scale.clamp(!0), t.primaryCoord = n.scale(t.primary), t.secondaryCoord = r.scale(t.secondary), t.x = i.scale(t.xValue), t.y = o.scale(t.yValue), t.defined = v.isValidPoint(t.xValue) && v.isValidPoint(t.yValue), t.base = n.vertical ? i.scale(t.baseValue) : o.scale(t.baseValue), r.scale.clamp(!1), "ordinal" === i.type && (t.x += i.tickOffset), "ordinal" === o.type && (t.y += o.tickOffset), t.anchor = {
      x: t.x,
      y: t.y
    }, t.boundingPoints = [t.anchor, {
      x: n.vertical ? "left" === n.position ? t.base - 1 : t.base : t.anchor.x,
      y: n.vertical ? t.anchor.y : "bottom" === n.position ? t.base - 1 : t.base
    }];
  }, Ro.buildStyles = function (t, e) {
    var n = e.defaultColors,
        r = {
      color: n[t.index % (n.length - 1)]
    };
    v.buildStyleGetters(t, r);
  };

  var Lo = function Lo(t) {
    var n = t.datum,
        r = t.style,
        i = t.all,
        o = t.index,
        a = i[o - 1] || {
      defined: !1
    },
        s = i[o + 1] || {
      defined: !1
    },
        c = vo(n),
        l = {
      x1: !n || Number.isNaN(n.x) ? null : n.x,
      y1: !n || Number.isNaN(n.base) ? null : n.base,
      x2: !n || Number.isNaN(n.x) ? null : n.x,
      y2: !n || Number.isNaN(n.y) ? null : n.y,
      style: u({}, No, {}, r, {}, r.line, {}, c, {}, c.line)
    };
    return _o(function () {
      return !n.defined || a.defined || s.defined ? null : e.createElement($i, l);
    }, l);
  };

  function Po(t) {
    var n = t.series,
        r = y(e.useContext(x), 1)[0].primaryAxes,
        i = xo(n),
        o = (n.primaryAxisID ? r.find(function (t) {
      return t.id === n.primaryAxisID;
    }) : r[0]).barOffset;
    return e.createElement("g", {
      className: "series bar"
    }, n.datums.map(function (t, n) {
      return e.createElement(Oo, a({
        key: n
      }, {
        datum: t,
        barOffset: o,
        style: i
      }));
    }));
  }

  function Oo(t) {
    var n,
        r,
        i,
        o,
        a = t.datum,
        s = t.barOffset,
        c = t.style,
        l = y(e.useContext(x), 2),
        h = l[0].primaryAxes,
        f = l[1],
        d = a ? a.x : 0,
        p = a ? a.y : 0,
        g = a ? a.base : 0,
        m = a ? a.size : 0;
    h.find(function (t) {
      return t.vertical;
    }) ? (n = g, i = d, o = (r = p + s) + m) : (i = (n = d + s) + m, r = p, o = g);

    var _ = vo(a),
        v = {
      style: u({
        pointerEvents: "all"
      }, c, {}, c.rectangle, {}, _, {}, _.rectangle),
      x1: Number.isNaN(n) ? null : n,
      y1: Number.isNaN(r) ? null : r,
      x2: Number.isNaN(i) ? null : i,
      y2: Number.isNaN(o) ? null : o,
      onMouseEnter: function onMouseEnter(t) {
        return f(function (t) {
          return u({}, t, {
            element: a
          });
        });
      },
      onMouseLeave: function onMouseLeave(t) {
        return f(function (t) {
          return u({}, t, {
            element: null
          });
        });
      }
    };

    return _o(function () {
      return e.createElement(q, v);
    }, v);
  }

  Po.plotDatum = function (t, e) {
    var n = e.xAxis,
        r = e.yAxis,
        i = e.primaryAxis,
        o = e.secondaryAxis;

    if (o.scale.clamp(!0), t.primaryCoord = i.scale(t.primary), t.secondaryCoord = o.scale(t.secondary), t.x = n.scale(t.xValue), t.y = r.scale(t.yValue), t.defined = v.isValidPoint(t.xValue) && v.isValidPoint(t.yValue), t.base = o.scale(t.baseValue), t.size = i.barSize, o.scale.clamp(!1), !o.stacked) {
      t.size = i.seriesBarSize;
      var a = i.seriesBandScale(t.seriesTypeIndex);
      o.vertical ? t.x += a : t.y += a;
    }

    t.anchor = {
      x: t.x,
      y: t.y,
      horizontalPadding: o.vertical ? t.size / 2 : 0,
      verticalPadding: o.vertical ? 0 : t.size / 2
    }, i.vertical ? t.anchor.y += "ordinal" !== i.type ? 0 : t.size / 2 : t.anchor.x += "ordinal" !== i.type ? 0 : t.size / 2, t.boundingPoints = [t.anchor, {
      x: i.vertical ? "left" === i.position ? t.base + 1 : t.base : t.anchor.x,
      y: i.vertical ? t.anchor.y : "bottom" === i.position ? t.base - 1 : t.base
    }];
  }, Po.buildStyles = function (t, e) {
    var n = e.defaultColors,
        r = {
      color: n[t.index % (n.length - 1)]
    };
    v.buildStyleGetters(t, r);
  };
  var Uo,
      Io = {
    line: ko,
    bubble: Eo,
    area: Ro,
    bar: Po
  },
      Vo = {
    type: "line",
    showPoints: !0,
    showOrphans: !0,
    curve: ji
  },
      zo = (o(Uo = {}, "linear", function t() {
    var e = je();
    return e.copy = function () {
      return Ve(e, t());
    }, jt.apply(e, arguments), en(e);
  }), o(Uo, "log", function t() {
    var e = ln(ze()).domain([1, 10]);
    return e.copy = function () {
      return Ve(e, t()).base(e.base());
    }, jt.apply(e, arguments), e;
  }), o(Uo, "time", function () {
    return jt.apply(Qr(Cn, wn, vn, _n, mn, gn, pn, yn, Vn).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
  }), o(Uo, "utc", function () {
    return jt.apply(Qr(Ln, Rn, Tn, An, Sn, kn, pn, yn, zn).domain([Date.UTC(2e3, 0, 1), Date.UTC(2e3, 0, 2)]), arguments);
  }), o(Uo, "ordinal", Ht), Uo);

  function jo(t) {
    var e = t.axis,
        n = e.primary,
        r = e.type,
        i = e.invert,
        o = e.position,
        a = e.primaryAxisID,
        s = e.min,
        u = void 0 === s ? void 0 : s,
        c = e.max,
        l = void 0 === c ? void 0 : c,
        h = e.hardMin,
        f = void 0 === h ? void 0 : h,
        d = e.hardMax,
        y = void 0 === d ? void 0 : d,
        g = e.base,
        m = void 0 === g ? void 0 : g,
        _ = e.tickCount,
        x = void 0 === _ ? "auto" : _,
        b = e.minTickCount,
        M = void 0 === b ? 0 : b,
        w = e.maxTickCount,
        C = void 0 === w ? 1 / 0 : w,
        k = e.tickValues,
        S = void 0 === k ? null : k,
        A = e.format,
        E = void 0 === A ? null : A,
        T = e.tickSizeInner,
        D = void 0 === T ? 6 : T,
        N = e.tickSizeOuter,
        R = void 0 === N ? 6 : N,
        L = e.tickPadding,
        P = void 0 === L ? 14 : L,
        O = e.maxLabelRotation,
        U = void 0 === O ? 50 : O,
        I = e.labelRotationStep,
        V = void 0 === I ? 5 : I,
        z = e.innerPadding,
        j = void 0 === z ? .2 : z,
        F = e.outerPadding,
        B = void 0 === F ? .1 : F,
        H = e.showGrid,
        Y = void 0 === H ? null : H,
        W = e.showTicks,
        q = void 0 === W || W,
        X = e.show,
        G = void 0 === X || X,
        Z = e.stacked,
        $ = void 0 !== Z && Z,
        K = e.id,
        J = t.materializedData,
        Q = t.gridHeight,
        tt = t.gridWidth;
    t.axisDimensions;
    if (!o) throw new Error("Chart axes must have a valid 'position' property");

    for (var et, nt, rt, it = n ? "primary" : "secondary", ot = !n && "primary", at = "".concat(it, "AxisID"), st = function (t) {
      return [no, eo].indexOf(t) > -1;
    }(o), ut = function (t) {
      return [to, eo].indexOf(t) > -1;
    }(o), ct = K || "".concat(o, "_").concat(r), lt = [], ht = {}, ft = {}, dt = 0; dt < J.length; dt++) {
      if (!J[dt][at] || J[dt][at] === ct) for (var yt = 0; yt < J[dt].datums.length; yt++) {
        var pt = J[dt].datums[yt],
            gt = void 0,
            mt = ot ? pt[ot] : yt;
        "ordinal" === r ? -1 === lt.indexOf() && lt.push(J[dt].datums[yt][it]) : gt = "time" === r || "utc" === r ? +pt[it] : pt[it], $ ? gt > 0 ? ft[mt] = void 0 !== ft[mt] ? ft[mt] + gt : gt : ht[mt] = void 0 !== ht[mt] ? ht[mt] + gt : gt : (et = void 0 !== et ? Math.min(et, gt) : gt, nt = void 0 !== nt ? Math.max(nt, gt) : gt);
      }
    }

    rt = "ordinal" === r ? lt : $ ? [Math.min.apply(Math, [0].concat(p(Object.values(ht)))), Math.max.apply(Math, [0].concat(p(Object.values(ft))))] : [et, nt];

    var _t,
        xt,
        vt = [0, st ? Q : tt];

    st && !n && vt.reverse();

    var bt = 0,
        Mt = 0,
        wt = 0,
        Ct = function Ct(t) {
      return t;
    },
        kt = 1;

    ("ordinal" === r || n) && ((xt = Ht().domain(J.reduce(function (t, e) {
      return e.datums.length > t.length ? e.datums : t;
    }, []).map(function (t) {
      return t.primary;
    })).rangeRound(vt, .1).padding(0)).paddingOuter(B).paddingInner(j), bt = xt.bandwidth(), "ordinal" === r && (Mt = bt), wt = xt.step(), kt = (Ct = Ht().paddingInner(j / 2).domain(J.filter(function (t) {
      return t.Component === Po;
    }).map(function (t, e) {
      return e;
    })).rangeRound([0, bt])).bandwidth()), _t = "ordinal" === r ? xt : zo[r](), "number" == typeof m && (rt[0] = Math.min(rt[0], m), rt[1] = Math.max(rt[1], m)), "number" == typeof defaultMin && (rt[0] = Math.min(rt[0], u)), "number" == typeof defaultMax && (rt[1] = Math.max(rt[1], l)), _t.domain(rt), "ordinal" !== r && _t.nice(), "number" == typeof f && _t.domain([f, _t.domain()[1]]), "number" == typeof y && _t.domain([_t.domain()[0], y]), i && _t.domain(p(_t.domain()).reverse()), _t.range(vt);
    var St = _t.tickFormat ? _t.tickFormat() : v.identity,
        At = E ? function () {
      return E(St.apply(void 0, arguments));
    } : St,
        Et = {
      id: ct,
      primary: n,
      type: r,
      invert: i,
      position: o,
      primaryAxisID: a,
      hardMin: f,
      hardMax: y,
      base: m,
      tickCount: x,
      minTickCount: M,
      maxTickCount: C,
      tickValues: S,
      tickSizeInner: D,
      tickSizeOuter: R,
      tickPadding: P,
      maxLabelRotation: U,
      labelRotationStep: V,
      innerPadding: j,
      outerPadding: B,
      showGrid: Y,
      showTicks: q,
      show: G,
      stacked: $,
      scale: _t,
      uniqueVals: lt,
      vertical: st,
      RTL: ut,
      barSize: bt,
      cursorSize: Mt,
      stepSize: wt,
      seriesBandScale: Ct,
      seriesBarSize: kt,
      domain: rt,
      range: vt,
      max: "bottom" === o ? -Q : o === no ? tt : o === to ? Q : -tt,
      directionMultiplier: o === to || o === no ? -1 : 1,
      transform: st ? v.translateY : v.translateX,
      ticks: S || _t.ticks ? _t.ticks() : _t.domain(),
      format: At,
      spacing: Math.max(D, 0) + P
    };
    return "ordinal" === r ? (Et.gridOffset = -Et.stepSize * j / 2, Et.tickOffset = Et.barSize / 2, Et.barOffset = 0) : (Et.tickOffset = 0, Et.barOffset = -Et.barSize / 2), Et;
  }

  function Fo(t) {
    return jo(t);
  }

  var Bo = ["#4ab5eb", "#fc6868", "#DECF3F", "#60BD68", "#FAA43A", "#c63b89", "#1aaabe", "#734fe9", "#1828bd", "#cd82ad"];

  function Ho(t) {
    var n = t.datum,
        r = t.grouping,
        i = t.primaryAxis,
        o = t.secondaryAxis,
        a = t.formatSecondary,
        s = t.formatTertiary,
        c = t.getStyle,
        l = t.dark;
    if (!n) return null;

    var h = s || function (t) {
      return Math.floor(t) < t ? Math.round(100 * t) / 100 : t;
    },
        f = p(n.group).sort(function (t, e) {
      if (!i.stacked && r === io || r === ao) {
        if (t.primaryCoord > e.primaryCoord) return -1;
        if (t.primaryCoord < e.primaryCoord) return 1;
      } else if (!o.stacked) {
        if (t.secondaryCoord > e.secondaryCoord) return -1;
        if (t.secondaryCoord < e.secondaryCoord) return 1;
      }

      return t.seriesIndex > e.seriesIndex ? 1 : -1;
    });

    r === oo && f.reverse(), o.invert && f.reverse();
    var d = f.length,
        y = f.findIndex(function (t) {
      return t === n;
    }),
        g = y > -1 ? y - 5 : 0;
    g = Math.max(g, 0);
    var m = y > -1 ? g + 10 : d;
    m = Math.min(m, d), g = Math.max(m - 10, 0);

    var _ = f.slice(g, m),
        x = g > 0,
        v = m < d;

    return e.createElement("div", null, e.createElement("div", {
      style: {
        marginBottom: "3px",
        textAlign: "center"
      }
    }, r === io ? e.createElement("strong", null, n.seriesLabel) : r === ao ? e.createElement("strong", null, n.secondaryAxis.format(n.secondary)) : e.createElement("strong", null, n.primaryAxis.format(n.primary))), e.createElement("table", {
      style: {
        whiteSpace: "nowrap"
      }
    }, e.createElement("tbody", null, x ? e.createElement("tr", {
      style: {
        opacity: .8
      }
    }, e.createElement("td", null), e.createElement("td", null, "..."), e.createElement("td", null)) : null, _.map(function (t, o) {
      var s = t === n,
          f = function (t, e) {
        return e || t.secondaryAxis.format || function (t) {
          return Math.floor(t) < t ? Math.round(100 * t) / 100 : t;
        };
      }(t, a);

      return e.createElement("tr", {
        key: o,
        style: {
          opacity: s ? 1 : .8,
          fontWeight: s && "bold"
        }
      }, e.createElement("td", {
        style: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginRight: "5px"
        }
      }, e.createElement("svg", {
        width: "16",
        height: "16"
      }, e.createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: u({}, c(t), {
          stroke: l ? "black" : "white",
          strokeWidth: s ? 2 : 1
        })
      }))), r === io ? e.createElement(e.Fragment, null, e.createElement("td", null, i.format(t.primary), ":  "), e.createElement("td", {
        style: {
          textAlign: "right"
        }
      }, f(t.secondary), t.r ? " (".concat(h(t.r), ")") : null)) : r === ao ? e.createElement(e.Fragment, null, e.createElement("td", null, t.seriesLabel, ":  "), e.createElement("td", {
        style: {
          textAlign: "right"
        }
      }, i.format(t.primary), t.r ? " (".concat(h(t.r), ")") : null)) : e.createElement(e.Fragment, null, e.createElement("td", null, t.seriesLabel, ":  "), e.createElement("td", {
        style: {
          textAlign: "right"
        }
      }, f(t.secondary), t.r ? " (".concat(h(t.r), ")") : null)));
    }), v ? e.createElement("tr", {
      style: {
        opacity: .8
      }
    }, e.createElement("td", null), e.createElement("td", null, "..."), e.createElement("td", null)) : null, o && o.stacked && n.group.length > 1 ? e.createElement("tr", null, e.createElement("td", {
      style: {
        paddingTop: "5px"
      }
    }, e.createElement("div", {
      style: {
        width: "12px",
        height: "12px",
        backgroundColor: l ? "rgba(0, 26, 39, 0.3)" : "rgba(255,255,255,.2)",
        borderRadius: "50px"
      }
    })), e.createElement("td", {
      style: {
        paddingTop: "5px"
      }
    }, "Total:  "), e.createElement("td", {
      style: {
        paddingTop: "5px"
      }
    }, o.format(p(n.group).reverse()[0].totalValue))) : null)));
  }

  var Yo = {
    render: function render(t) {
      var n = t.formattedValue;
      return e.createElement("span", null, n);
    },
    snap: !0,
    showLine: !0,
    showLabel: !0,
    axisID: void 0,
    onChange: function onChange() {}
  },
      Wo = {
    getDatums: function getDatums(t) {
      return Array.isArray(t) ? t : t.datums || t.data;
    },
    getLabel: function getLabel(t, e) {
      return t.label || "Series ".concat(e + 1);
    },
    getSeriesID: function getSeriesID(t, e) {
      return e;
    },
    getPrimary: function getPrimary(t) {
      return Array.isArray(t) ? t[0] : t.primary || t.x;
    },
    getSecondary: function getSecondary(t) {
      return Array.isArray(t) ? t[1] : t.secondary || t.y;
    },
    getR: function getR(t) {
      return Array.isArray(t) ? t[2] : t.radius || t.r;
    },
    getPrimaryAxisID: function getPrimaryAxisID(t) {
      return t.primaryAxisID;
    },
    getSecondaryAxisID: function getSecondaryAxisID(t) {
      return t.secondaryAxisID;
    },
    getSeriesStyle: function getSeriesStyle(t) {
      return {
        color: t.originalSeries.color
      };
    },
    getDatumStyle: function getDatumStyle() {
      return {};
    },
    getSeriesOrder: function getSeriesOrder(t) {
      return t;
    },
    onHover: function onHover() {},
    grouping: oo,
    focus: "auto",
    showVoronoi: !1
  };

  function qo(t) {
    var n = t.data,
        r = t.grouping,
        i = t.focus,
        o = t.showVoronoi,
        s = t.dark,
        c = t.series,
        l = t.axes,
        f = t.primaryCursor,
        d = t.secondaryCursor,
        g = t.tooltip,
        m = t.brush,
        _ = t.renderSVG,
        b = t.getDatums,
        M = t.getLabel,
        w = t.getSeriesID,
        C = t.getPrimary,
        k = t.getSecondary,
        S = t.getR,
        A = t.getPrimaryAxisID,
        E = t.getSecondaryAxisID,
        T = t.getSeriesStyle,
        P = t.getDatumStyle,
        O = t.onClick,
        U = t.onFocus,
        I = t.onHover,
        V = t.getSeriesOrder,
        z = h(t, ["data", "grouping", "focus", "showVoronoi", "dark", "series", "axes", "primaryCursor", "secondaryCursor", "tooltip", "brush", "renderSVG", "getDatums", "getLabel", "getSeriesID", "getPrimary", "getSecondary", "getR", "getPrimaryAxisID", "getSecondaryAxisID", "getSeriesStyle", "getDatumStyle", "onClick", "onFocus", "onHover", "getSeriesOrder"]),
        j = y(e.useState({
      focused: null,
      element: null,
      axisDimensions: {},
      padding: {},
      offset: {},
      pointer: {}
    }), 2),
        F = j[0],
        B = F.focused,
        H = F.element,
        Y = F.axisDimensions,
        W = F.offset,
        q = F.padding,
        X = F.pointer,
        G = j[1],
        Z = N(O),
        $ = N(U),
        K = N(I),
        J = e.useRef(),
        Q = D(J),
        tt = Q.width,
        et = Q.height,
        nt = function (t) {
      var n = t.data,
          r = t.getSeriesID,
          i = t.getLabel,
          o = t.getPrimaryAxisID,
          a = t.getSecondaryAxisID,
          s = t.getDatums,
          u = t.getPrimary,
          c = t.getSecondary,
          l = t.getR;
      return e.useMemo(function () {
        for (var t = [], e = 0; e < n.length; e++) {
          for (var h = n[e], f = r(h, e, n), d = i(h, e, n), y = o(h, e, n), p = a(h, e, n), g = s(h, e, n), m = [], _ = 0; _ < g.length; _++) {
            var x = g[_];
            m[_] = {
              originalSeries: h,
              seriesIndex: e,
              seriesID: f,
              seriesLabel: d,
              index: _,
              originalDatum: x,
              primary: u(x, _, h, e, n),
              secondary: c(x, _, h, e, n),
              r: l(x, _, h, e, n)
            };
          }

          t[e] = {
            originalSeries: h,
            index: e,
            id: f,
            label: d,
            primaryAxisID: y,
            secondaryAxisID: p,
            datums: m
          };
        }

        return t;
      }, [n, s, i, u, o, l, c, a, r]);
    }({
      data: n,
      getSeriesID: w = e.useCallback(v.normalizeGetter(w), [w]),
      getLabel: M = e.useCallback(v.normalizeGetter(M), [M]),
      getPrimaryAxisID: A = e.useCallback(v.normalizeGetter(A), [A]),
      getSecondaryAxisID: E = e.useCallback(v.normalizeGetter(E), [E]),
      getDatums: b = e.useCallback(v.normalizeGetter(b), [b]),
      getPrimary: C = e.useCallback(v.normalizeGetter(C), [C]),
      getSecondary: k = e.useCallback(v.normalizeGetter(k), [k]),
      getR: S = e.useCallback(v.normalizeGetter(S), [S])
    }),
        rt = function (t) {
      var n = t.materializedData,
          r = t.series;
      return e.useMemo(function () {
        return n.map(function (t, e) {
          var n = u({}, Vo, {}, "function" == typeof r ? r(t, e) : r),
              i = n.type,
              o = h(n, ["type"]),
              a = Io[i];
          if (!a) throw new Error("Could not find a registered series type for ".concat(i));
          return u({}, o, {
            type: i,
            renderer: a
          });
        });
      }, [n, r]);
    }({
      materializedData: nt,
      series: c
    });

    nt = function (t) {
      var n = t.materializedData,
          r = t.seriesOptions;
      return e.useMemo(function () {
        return n.map(function (t, e) {
          return t.Component = r[e].renderer, t;
        }).map(function (t, e, n) {
          var r = n.filter(function (n, r) {
            return r < e && n.Component === t.Component;
          }).length;
          return u({}, t, {
            seriesTypeIndex: r,
            datums: t.datums.map(function (t) {
              return u({}, t, {
                seriesTypeIndex: r
              });
            })
          });
        });
      }, [n, r]);
    }({
      materializedData: nt,
      seriesOptions: rt
    });

    var it = function (t) {
      var n = t.width,
          r = t.height,
          i = t.axisDimensions,
          o = t.padding,
          a = t.offset;
      a = e.useMemo(function () {
        return {
          left: a.left || 0,
          top: a.top || 0
        };
      }, [a]);
      var s = e.useMemo(function () {
        var t = i.left && v.sumObjBy(i.left, "width") || 0,
            e = i.left && v.sumObjBy(i.left, "top") || 0,
            a = i.left && v.sumObjBy(i.left, "bottom") || 0,
            s = i.right && v.sumObjBy(i.right, "width") || 0,
            u = i.right && v.sumObjBy(i.right, "top") || 0,
            c = i.right && v.sumObjBy(i.right, "bottom") || 0,
            l = i.top && v.sumObjBy(i.top, "height") || 0,
            h = i.top && v.sumObjBy(i.top, "left") || 0,
            f = i.top && v.sumObjBy(i.top, "right") || 0,
            d = i.bottom && v.sumObjBy(i.bottom, "height") || 0,
            y = i.bottom && v.sumObjBy(i.bottom, "left") || 0,
            p = i.bottom && v.sumObjBy(i.bottom, "right") || 0,
            g = o.left || 0,
            m = o.right || 0,
            _ = o.top || 0,
            x = o.bottom || 0;

        return {
          gridX: g + Math.max(t, h, y),
          gridY: _ + Math.max(l, e, u),
          gridWidth: n - g - m - Math.max(t, h, y) - Math.max(s, f, p),
          gridHeight: r - _ - x - Math.max(l, e, u) - Math.max(d, a, c)
        };
      }, [n, r, i, o]),
          u = s.gridX,
          c = s.gridY,
          l = s.gridWidth,
          h = s.gridHeight;
      return {
        offset: a,
        gridX: u,
        gridY: c,
        gridWidth: l,
        gridHeight: h
      };
    }({
      width: tt,
      height: et,
      axisDimensions: Y,
      padding: q,
      offset: W
    }),
        ot = it.offset,
        at = it.gridX,
        st = it.gridY,
        ut = it.gridWidth,
        ct = it.gridHeight,
        lt = function (t) {
      var n = t.axes,
          r = t.materializedData,
          i = t.gridHeight,
          o = t.gridWidth,
          a = t.axisDimensions,
          s = n.filter(function (t) {
        return t.primary;
      }),
          u = n.filter(function (t) {
        return !t.primary;
      }),
          c = JSON.stringify(s),
          l = JSON.stringify(u),
          h = e.useMemo(function () {
        return s.map(function (t, e) {
          return Fo({
            axis: t,
            materializedData: r,
            gridWidth: o,
            gridHeight: i,
            axisDimensions: a
          });
        });
      }, [c, r, i, o]),
          f = e.useMemo(function () {
        return u.map(function (t, e) {
          return Fo({
            axis: t,
            primaryAxes: h,
            materializedData: r,
            gridWidth: o,
            gridHeight: i,
            axisDimensions: a
          });
        });
      }, [l, r, i, o]),
          d = h.find(function (t) {
        return t.vertical;
      }) ? "secondary" : "primary",
          y = h.find(function (t) {
        return t.vertical;
      }) ? "primary" : "secondary",
          p = h.find(function (t) {
        return t.vertical;
      }) ? f : h,
          g = h.find(function (t) {
        return t.vertical;
      }) ? h : f;
      return {
        primaryAxes: h,
        secondaryAxes: f,
        xKey: d,
        yKey: y,
        xAxes: p,
        yAxes: g
      };
    }({
      axes: l,
      materializedData: nt,
      gridHeight: ct,
      gridWidth: ut,
      axisDimensions: Y
    }),
        ht = lt.primaryAxes,
        ft = lt.secondaryAxes,
        dt = lt.xKey,
        yt = lt.yKey,
        pt = lt.xAxes,
        gt = lt.yAxes,
        mt = function (t) {
      var n = t.materializedData,
          r = t.primaryAxes,
          i = t.secondaryAxes,
          o = t.yAxes,
          a = t.yKey,
          s = t.xAxes,
          c = t.xKey,
          l = t.grouping;
      return e.useMemo(function () {
        if (!r.length || !i.length) throw new Error("A primary and secondary axis is required!");
        var t = i.map(function () {
          return {};
        });
        n.forEach(function (e) {
          var n = v.getAxisIndexByAxisID(i, e.secondaryAxisID);
          e.datums.forEach(function (e) {
            t[n][e.primary] = {
              negative: 0,
              positive: 0
            };
          });
        });
        var e = n.map(function (e) {
          var n = v.getAxisIndexByAxisID(r, e.primaryAxisID),
              o = r[n],
              s = v.getAxisIndexByAxisID(i, e.secondaryAxisID),
              l = i[s];
          return u({}, e, {
            primaryAxis: o,
            secondaryAxis: l,
            datums: e.datums.map(function (e) {
              var n = u({}, e, {
                primaryAxis: o,
                secondaryAxis: l,
                xValue: e[c],
                yValue: e[a],
                baseValue: 0
              });

              if (l.stacked) {
                var r = t[s][e.primary];

                if (o.vertical) {
                  var i = v.isValidPoint(n.xValue),
                      h = n.xValue >= 0 ? "positive" : "negative";
                  n.baseValue = r[h], n.totalValue = n.baseValue + (i ? n.xValue : 0), t[s][e.primary][h] = n.totalValue, n.xValue = i ? n.totalValue : null;
                } else {
                  var f = v.isValidPoint(n.yValue),
                      d = n.yValue >= 0 ? "positive" : "negative";
                  n.baseValue = r[d], n.totalValue = n.baseValue + (f ? n.yValue : 0), t[s][e.primary][d] = n.totalValue, n.yValue = f ? n.totalValue : null;
                }
              }

              return n;
            })
          });
        });
        if (e.forEach(function (t) {
          t.datums.forEach(function (e) {
            e.series = t;
          });
        }), e.forEach(function (t, e) {
          if (!t.Component.plotDatum) throw new Error("Could not find a [SeriesType].plotDatum() static method for the series Component above (index: ".concat(e, ")"));
          var n = v.getAxisIndexByAxisID(r, t.primaryAxisID),
              u = v.getAxisIndexByAxisID(i, t.secondaryAxisID),
              l = r[n],
              h = i[u],
              f = v.getAxisIndexByAxisID(s, t["".concat(c, "AxisID")]),
              d = v.getAxisIndexByAxisID(o, t["".concat(a, "AxisID")]),
              y = s[f],
              p = o[d];
          t.datums = t.datums.map(function (e) {
            return t.Component.plotDatum(e, {
              primaryAxis: l,
              secondaryAxis: h,
              xAxis: y,
              yAxis: p
            }) || e;
          });
        }), [ro, io].includes(l)) for (var h = 0; h < e.length; h++) {
          for (var f = e[h], d = 0; d < f.datums.length; d++) {
            var y = f.datums[d];
            y.group = l === io ? y.series.datums : [y];
          }
        } else if ([oo, ao].includes(l)) {
          for (var p = {}, g = 0; g < e.length; g++) {
            for (var m = e[g], _ = 0; _ < m.datums.length; _++) {
              var x = m.datums[_];

              if (x.defined) {
                var b = String(l === oo ? x.primary : x.secondary);
                p[b] = p[b] || [], p[b].push(x);
              }
            }
          }

          for (var M = 0; M < e.length; M++) {
            for (var w = e[M], C = 0; C < w.datums.length; C++) {
              var k = w.datums[C],
                  S = String(l === oo ? k.primary : k.secondary);
              k.group = p[S];
            }
          }
        }
        return e = e.map(function (t, e) {
          if (!t.Component.buildStyles) throw new Error("Could not find a SeriesType.buildStyles() static method for the series Component above (index: ".concat(e, ")"));
          return t.Component.buildStyles(t, {
            defaultColors: Bo
          }) || t;
        });
      }, [r, i, n, l, c, a, s, o]);
    }({
      materializedData: nt,
      primaryAxes: ht,
      secondaryAxes: ft,
      yAxes: gt,
      yKey: yt,
      xAxes: pt,
      xKey: dt,
      grouping: r
    });

    X = e.useMemo(function () {
      return u({}, X, {
        axisValues: [].concat(p(ht), p(ft)).map(function (t) {
          return {
            axis: t,
            value: t.scale.invert ? t.scale.invert(X[t.vertical ? "y" : "x"]) : null
          };
        })
      });
    }, [X, ht, ft]);

    var _t = R(B = e.useMemo(function () {
      if (B || H) {
        var t = i;
        if ("auto" === i && (t = H ? "element" : "closest"), "element" === t && H) return H;
        if ("closest" === t) return v.getClosestPoint(X, B.group);
      }

      return null;
    }, [H, i, B, X]), B);

    g = function (t) {
      var n = t.focused,
          r = t.tooltip,
          i = t.pointer,
          o = t.gridWidth,
          a = t.gridHeight;
      return e.useMemo(function () {
        if (!r) return null;
        r = u({
          align: "auto",
          alignPriority: ["right", "topRight", "bottomRight", "left", "topLeft", "bottomLeft", "top", "bottom"],
          padding: 5,
          tooltipArrowPadding: 7,
          anchor: "closest",
          render: Ho,
          onChange: function onChange() {}
        }, r);
        var t = {},
            e = !0;
        if (n ? t = n.anchor : e = !1, "pointer" === r.anchor) t = i;else if ("closest" === r.anchor) ;else if (n) {
          var s = Array.isArray(r.anchor) ? p(r.anchor) : [r.anchor];
          t = v.getMultiAnchor({
            anchor: s,
            points: n.group,
            gridWidth: o,
            gridHeight: a
          });
        }
        return t = t ? u({
          horizontalPadding: t.horizontalPadding || 0,
          verticalPadding: t.verticalPadding || 0
        }, t) : t, u({}, r, {
          anchor: t,
          show: e
        });
      }, [n, a, o, i, r]);
    }({
      focused: B,
      tooltip: g,
      pointer: X,
      gridWidth: ut,
      gridHeight: ct
    });

    var xt = y(function (t) {
      var n = t.primaryCursor,
          r = t.secondaryCursor,
          i = t.primaryAxes,
          o = t.secondaryAxes,
          a = t.focused,
          s = t.pointer,
          c = t.gridWidth,
          l = t.gridHeight,
          h = t.stackData;
      return [n, r].map(function (t, n) {
        var r = t && t.value;
        return e.useMemo(function () {
          if (t) {
            var e,
                r = 0 === n;
            t = u({}, Yo, {}, t, {
              primary: r
            });

            var h = !1,
                f = v.getAxisByAxisID(r ? i : o, t.axisID || a ? a.series[r ? "primaryAxisID" : "secondaryAxisID"] : void 0),
                d = r ? o[0] : i[0],
                y = f.scale.invert || function (t) {
              return t;
            };

            if (s.active) {
              var p = s.x,
                  g = s.y;
              h = !(p < -1 || p > c + 1 || g < -1 || g > l + 1), "ordinal" === f.type || t.snap ? a ? e = f.vertical ? a.yValue : a.xValue : h = !1 : e = f.vertical ? y(g) : y(p);
            } else h = !1;

            var m = h,
                _ = e;
            return void 0 !== t.value && null !== t.value && (_ = t.value, m = void 0 === t.show || t.show, void 0 === f.scale(_) && (m = !1)), u({}, t, {
              axis: f,
              siblingAxis: d,
              show: h,
              value: e,
              resolvedShow: m,
              resolvedValue: _
            });
          }
        }, [h, s, r]);
      });
    }({
      primaryCursor: f,
      secondaryCursor: d,
      primaryAxes: ht,
      secondaryAxes: ft,
      focused: B,
      pointer: X,
      gridWidth: ut,
      gridHeight: ct,
      stackData: mt
    }), 2);
    f = xt[0], d = xt[1], e.useEffect(function () {
      $.current && $.current(B);
    }, [$, B]), e.useEffect(function () {
      K.current && K.current(X);
    }, [K, X]);
    var vt = L(X.dragging);
    e.useEffect(function () {
      if (m && vt && !X.dragging) {
        if (Math.abs(X.sourceX - X.x) < 20) return;
        m.onSelect({
          pointer: X.released,
          start: ht[0].scale.invert(X.sourceX),
          end: ht[0].scale.invert(X.x)
        });
      }
    }, [m, X, X.released, X.sourceX, X.x, vt, ht]);
    var bt = e.useMemo(function () {
      return {
        focused: B,
        latestFocused: _t,
        pointer: X,
        tooltip: g,
        axisDimensions: Y,
        offset: ot,
        padding: q,
        width: tt,
        height: et,
        brush: m,
        grouping: r,
        showVoronoi: o,
        materializedData: nt,
        stackData: mt,
        primaryAxes: ht,
        secondaryAxes: ft,
        primaryCursor: f,
        secondaryCursor: d,
        gridX: at,
        gridY: st,
        gridWidth: ut,
        gridHeight: ct,
        dark: s,
        renderSVG: _,
        xKey: dt,
        yKey: yt,
        xAxes: pt,
        yAxes: gt,
        onClickRef: Z,
        getSeriesStyle: T,
        getDatumStyle: P,
        seriesOptions: rt,
        getSeriesOrder: V
      };
    }, [Y, m, s, B, P, V, T, ct, ut, at, st, r, et, _t, nt, ot, Z, q, X, ht, f, _, ft, d, rt, o, mt, g, tt, pt, dt, gt, yt]),
        Mt = e.useMemo(function () {
      return [bt, G];
    }, [bt, G]);
    return e.createElement(x.Provider, {
      value: Mt
    }, e.createElement(mo, a({
      ref: J
    }, z, {
      onClick: function onClick(t) {
        Z.current && Z.current(B);
      }
    })));
  }

  qo.defaultProps = Wo, t.Chart = qo, t.alignAuto = "auto", t.alignBottom = "bottom", t.alignBottomLeft = "bottomLeft", t.alignBottomRight = "bottomRight", t.alignLeft = "left", t.alignRight = "right", t.alignTop = "top", t.alignTopLeft = "topLeft", t.alignTopRight = "topRight", t.anchorBottom = "bottom", t.anchorCenter = "center", t.anchorClosest = "closest", t.anchorGridBottom = "gridBottom", t.anchorGridLeft = "gridLeft", t.anchorGridRight = "gridRight", t.anchorGridTop = "gridTop", t.anchorLeft = "left", t.anchorPointer = "pointer", t.anchorRight = "right", t.anchorTop = "top", t.axisTypeLinear = "linear", t.axisTypeLog = "log", t.axisTypeOrdinal = "ordinal", t.axisTypeTime = "time", t.axisTypeUtc = "utc", t.curveBasis = function (t) {
    return new di(t);
  }, t.curveBasisClosed = function (t) {
    return new yi(t);
  }, t.curveBasisOpen = function (t) {
    return new pi(t);
  }, t.curveBundle = mi, t.curveCardinal = vi, t.curveCardinalClosed = Mi, t.curveCardinalOpen = Ci, t.curveCatmullRom = Ai, t.curveCatmullRomClosed = Ti, t.curveCatmullRomOpen = Ni, t.curveLinear = si, t.curveLinearClosed = function (t) {
    return new Ri(t);
  }, t.curveMonotoneX = ji, t.curveMonotoneY = function (t) {
    return new Vi(t);
  }, t.curveNatural = function (t) {
    return new Fi(t);
  }, t.curveStep = function (t) {
    return new Hi(t, .5);
  }, t.curveStepAfter = function (t) {
    return new Hi(t, 1);
  }, t.curveStepBefore = function (t) {
    return new Hi(t, 0);
  }, t.focusAuto = "auto", t.focusClosest = "closest", t.focusElement = "element", t.groupingPrimary = oo, t.groupingSecondary = ao, t.groupingSeries = io, t.groupingSingle = ro, t.positionBottom = "bottom", t.positionLeft = no, t.positionRight = eo, t.positionTop = to, Object.defineProperty(t, "__esModule", {
    value: !0
  });
});